import React, { useContext, useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { useHistory } from 'react-router-dom';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Grid, Card } from '@mui/material';
import Carrinho_Vazio_Imagem from '../../../src/assets/img/carrinho_vazio.svg';
import Question from '../../../src/assets/img/question.svg';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import { MyContext } from '../../context/MyContext';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialogo from '../Dialogo/Dialogo';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import CupomDescontoIcon from '../../assets/img/cupom_desconto.svg';
import LocalizacaoIcon from '../../assets/img/local.svg';
import BagIcon from '../../assets/img/bag.svg';
import Slide from '@mui/material/Slide';
import "./Carrinho.css";
import api from '../../services/api';
import Divider from '@mui/material/Divider';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PagamentoIcon from '../../assets/img/pagamento.svg';
import ChaveIcon from '../../assets/img/chave.svg';
import usuarioLogo from '../../assets/img/usuario.svg';
import cartoes_selecaoIcon from '../../assets/img/cartoes_selecao.svg';
import cartoes_selecaoIconDisabled from '../../assets/img/cartoes_selecao_disabled.svg';
import boletoIcon from '../../assets/img/boleto.svg';
import boletoIconDisabled from '../../assets/img/boleto_disabled.svg';
import pixIcon from '../../assets/img/pix.svg';
import pixIconDisabled from '../../assets/img/pix_disabled.svg';
import cartoes_AMEX from '../../assets/img/cartoes_amex.svg';
import cartoes_ELO from '../../assets/img/cartoes_elo.svg';
import cartoes_DINERS from '../../assets/img/cartoes_diners.svg';
import cartoes_VISA from '../../assets/img/cartoes_visa.svg';
import cartoes_MASTERCARD from '../../assets/img/cartoes_mastercard.svg';
import cartoes_HIPERCARD from '../../assets/img/cartoes_hipercard.svg';
import cartoes_HIPER from '../../assets/img/cartoes_hiper.svg';
import cartoes_CABAL from '../../assets/img/cartoes_cabal.svg';
import cartoes_CVV from '../../assets/img/cartoes_cvv.svg';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import { validaCpfCnpj, CartaoCreditoTipo, identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, identificacaoNomeUsuarioLogado, identificaoEnderecoEntrega } from './../../utils';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../Carrinho/Carrinho.css';
import ModalEndereco from '../../components/Pages/Enderecos/ModalEndereco';
import ModalMeuPedido from '../../components/Pages/Meu_Pedido/Modal_Meu_Pedido';
import { Prev } from "react-bootstrap/esm/PageItem";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import DetalhesMeuPedido from '../../components/Meu_Pedido/Meu_Pedido';
import DetalhesMeusCupons from '../../components/MeusCupons/MeusCupons';
import Backdrop from '@mui/material/Backdrop';
import { RepeatOneSharp } from "@mui/icons-material";
import Link from '@mui/material/Link';
import { PedidoIcon } from '@mui/icons-material/ShoppingBag';
import { BrowserView, MobileView } from 'react-device-detect';
import CircularProgress from '@mui/material/CircularProgress';
import ModalDetalhes from '../../components/Pages/PaginaProduto/ModalDetalhes';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
  


const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const newFormSend = new FormData();
    const cookies = new Cookies();
    const xsrfToken = cookies.get('XSRF-TOKEN');

    if (xsrfToken === null) {
        alert("AntiforgeryToken não está presente!");
        return;
    };

    let save = await api.post('Pedidos', newFormSend, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'X-XSRF-TOKEN': xsrfToken
        }
    }).then(res => {
        return res.data;
    }).catch(err => {
        // alert(err);
        return false;
    });
    if (save) {
        console.log("cliente foi salvo com sucesso")
    }
}

const modalStyle = {
    position: 'absolute',
    top: '10%',
    left: '10%',
    right: "10%",
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    bgcolor: 'background.paper',
    boxShadow: 24
}

const modalStyleQuestions = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '3px solid #008000',
    boxShadow: 24,
    p: 4,
};


function Carrinho_Produtos(props) {
    let navigate = useHistory();
    const [fechandoPedido, setFechandoPedido] = useState(false);
    const [open, setOpen] = useState(false);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [openMeusCupons, setOpenMeusCupons] = useState(false);
    const recaptchaRef = useRef(null);
    const [token, setToken] = useState('');    
    const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
    const { meuCredito, setMeuCredito } = useContext(MyContext);  // ID dos Créditos Selecionados Para Pagamentos
    const { meusCreditosSelecionados, setMeusCreditosSelecionados } = useContext(MyContext);  // Créditos Selecionados Para Pagamentos
    const { meuCreditoDetalhes, setMeuCreditoDetalhes } = useContext(MyContext); // Armazena os Dados dos Créditos a Serem utilizados no Ato de Pagamento
    const { showModalMeusCreditos, setShowModalMeusCreditos } = useContext(MyContext);
    const { usuarioComprasFaturadas, setUsuarioComprasFaturadas } = useContext(MyContext);
    const { showModalMeuPedido, setShowModalMeuPedido } = useContext(MyContext);
    const { meuEnderecoEntrega, setMeuEnderecoEntrega } = useContext(MyContext);
    const [atualizarPagina, setAtualizarPagina] = useState(false);
    const { carrinhoCounter, setCarrinhoCounter } = useContext(MyContext);
    const { showLoading, setShowLoading } = useContext(MyContext);
    const { meuFormaPagamentoTipo, setMeuFormaPagamentoTipo } = useContext(MyContext); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
    const [openDialogo, setOpenDialogo] = useState(false);
    const [dialogoMensagem, SetDialogoMensagem] = useState("");
    const [dialogoRetornoSim, setDialogoRetornoSim] = useState(false);
    const [dialogoProduto, setDialogoProduto] = useState({});
    const [fretes, setFretes] = useState([]);
    const [hasCep, setHasCep] = useState(false);
    const [cepDigitado, setCepDigitado] = useState("");
    const [cepEntregaSelecionado, setCepEntregaSelecionado] = useState({});
    const [freteError, setFreteError] = useState("");
    const [cpf_cnpjError, setCpf_cnpjError] = useState("");
    const [vencimentoError, setVencimentoError] = useState("");
    const [cartaoSelecionado, setCartaoSelecionado] = useState("cartoes_CVV");
    const [cartaoTipoCartao, setCartaoTipoCartao] = useState(0);
    const [cartaoSolicitarCPF_CNPJ, setCartaoSolicitarCPF_CNPJ] = useState(true);
    const [cartaoDigitadoNumero, setCartaoDigitadoNumero] = useState("");
    const [cartaoNumeroError, setCartaoNumeroError] = useState("");
    const [cartaoDigitadoNome, setCartaoDigitadoNome] = useState("");
    const [cartaoNomeError, setCartaoNomeError] = useState("");
    const [cartaoDigitadoValidade, setCartaoDigitadoValidade] = useState("");
    const [cartaoDigitadoCVV, setCartaoDigitadoCVV] = useState("");
    const [cartaoDigitadoCPFCNPJ, setCartaoDigitadoCCPFCNPJ] = useState("");
    const [atualizarFrete, setAtualizarFrete] = useState(false);
    const [tipoFrete, setTipoFrete] = useState(-1);
    const [tipoFreteDados, setTipoFreteDados] = useState({});
    const [tipoFretePrazo, setTipoFretePrazo] = useState(0);
    const [pagamentoNumeroMaximoParcelas, setPagamentoNumeroMaximoParcelas] = useState({});
    const [pagamentoNumeroParcelas, setPagamentoNumeroParcelas] = useState(0);
    const [pagamentoNumeroParcelasError, setPagamentoNumeroParcelasError] = useState("");
    const [pagamentoValorParcelas, setPagamentoValorParcelas] = useState([]);
    const [falhouPagamentos, setFalhouPagamentos] = useState("");
    const [confirmouCancelamento, setConfirmouCancelamento] = useState(false);    // usado para indicar se faltar item poderá ser cancelado
    const [confirmouCancelamentoError, setConfirmouCancelamentoError] = useState("");
    const [totalProdutos, setTotalProdutos] = useState(0.00);
    const [totalFrete, setTotalFrete] = useState(0.00);
    const [totalDescontos, setTotalDescontos] = useState(0.00);
    const [totalCreditos, setTotalCreditos] = useState(0.00);
    const [totalGeral, setTotalGeral] = useState(0.00);
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    // const [usuarioLogado, setUsuarioLogado] = useContext(MyContext);
    //const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado
    const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext);
    const [usuarioAssociadoMaisUmaConta, setUsuarioAssociadoMaisUmaConta] = useState(false); // Armazena Se o E-Mail Está Associado a Mais de Uma Conta (Normalmente Contas Faturadas)
    const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");
    const [pagamentoOpcaoSelecionada, setPagamentoOpcaoSelecionada] = useState("");
    const [retornoApi, setRetornoApi] = useState({});
    const { meuEspecie, setMeuEspecie } = useContext(MyContext);
    //const { meuCreditos, setMeuCreditos } = useContext(MyContext);
    const [descontoPagamentoAVista, setDescontoPagamentoAVista] = useState({});
    const [preVendaState, setPreVendaState] = useState({});
    const [preVendasItem, setPreVendasItem] = useState([]);
    const [especieItem, setEspecieItem] = useState({
        especie_id: 0,
        especie_loja: 998,  // 999
        venda_id: 0,
        venda_loja: 998,  // 999
        data: "1997-01-01T00:00:00",
        tipo: 0,
        valor: 0.00,
        vezes: 0,
        usuario: 0,
        caixa: 0,
        retorno: null,
        codctf: null,
        respdll: null,
        operadora_cnpj: null,
        cartao: "",
        bandeira: "",
        codautor: "",
        retautor: "",
        nsu: "",
        nsuautor: "",
        aprovacao: "",
        van: "",
        operadora: "",
        autorizadora: "",
        transacao: "1997-01-01 00:00:00",
        modo: "",
        resposta: "",
        nband: 0,
        disk: 1,
        finalizado: 0,
        tipo_integracao: 0,
        tid: "",
        presencial: 0,
        pix_txid: null,
        pix_validade: null,
        pix_recebido: null,
        pix_location: null,
        ordem: 0
    });

    const [pedidosWebClass, setPedidosWebClass] = useState({
        preVendas: {},
        // preVendasItensComMarcaClass: [],
        preVendasItens: [],
        especie: [],
        creditos: [],
        cartaoNumero: "",
        cartaoValidade: "",
        cartaoCVV: "",
        cartaoNome: "",
        idModeloTransporte: -1,
        pixCopiaCola: "",
        usuarioLogado: "",
        nomeUsuarioLogado: ""
    });

    const { setOpenMD } = useContext(MyContext);
    const [codigoClicado, setCodigoClicado] = useState(null);
    const onChangeToken = (token) => {
        setToken(token); // token válido do reCAPTCHA
      };

    const handleOpenModal = () => {
        // setOpen(true);
        setShowModalMeuPedido(true);
    }

    const handleCloseModal = () => {
        // setOpen(false);
        console.log("DENGUE ");
        setShowModalMeuPedido(false);
        navigate.push('/meus_pedidos');
    }

    const handleCloseModalQuestion = () => {
        setOpenQuestion(false);
    }

    const handleOpenModalMeusCreditos = () => {
        setOpenMeusCupons(true);
    }

    const handleCloseModalMeusCreditos = () => {
        setOpenMeusCupons(false);
    }

    const abrirPaginaModalDetalhes = (e) => {
        setCodigoClicado(e);
        setOpenMD(true);
    };


    function VerificarDigitacaoCartoes() {
        if (cartaoDigitadoNumero.replaceAll(" ", "").replace(/[^0-9]/, '').length < 14) {
            setCartaoNumeroError("Número do Cartão Inválido");
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoNome.replaceAll(" ", "").length < 8) {
            setCartaoNomeError("Nome do Portador do Cartão Inválido");
            return false;
        } else {
            setCartaoNumeroError("");
        }
        if (cartaoDigitadoValidade.replaceAll(" ", "").replace(/[^0-9]/, '').length < 4) {
            setVencimentoError("Validade do Cartão Inválida");
            return false;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoValidade.indexOf('/') == -1) {
            setVencimentoError("Ano de Vencimento Inválido");
        }
        if (cartaoDigitadoValidade.split('/')[0] <= '00' || cartaoDigitadoValidade.split('/')[0] >= '13') {
            setVencimentoError("Mês de Vencimento Inválido");
            return;
        }
        else {
            setVencimentoError("");
        }
        var anoAtual = new Date().getFullYear().toString();
        if (cartaoDigitadoValidade.split('/')[1] <= '00' || anoAtual != null && cartaoDigitadoValidade.split('/')[1] < anoAtual.substring(2, 4)) {
            setVencimentoError("Ano de Vencimento Inválido");
            return;
        } else {
            setVencimentoError("");
        }
        if (cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length < 3 || cartaoDigitadoCVV.replaceAll(" ", "").replace(/[^0-9]/, '').length > 4) {
            setVencimentoError("CVV do Cartão Inválido");
            return false;
        } else {
            setVencimentoError("");
        }
        if (pagamentoNumeroParcelas <= 0 || pagamentoNumeroParcelasError > 12) {
            setPagamentoNumeroParcelasError("Selecione o Número de Parcelas Desejado");
            return false;
        }
        else {
            setPagamentoNumeroParcelasError("");
        }
        if (confirmouCancelamento == false) {
            setConfirmouCancelamentoError("Será Necessário Marcar 'Concordo...' Pois as Lojas Físicas Estão Vendendo Simultâneamente");
            return false;
        } else {
            setConfirmouCancelamentoError("");
        }
        return true;
    }

    const UtilizarCreditoDigitado = (event) => {
        let cupomDescontoDigitado = document.getElementById("cupomDescontoText").value;
        if (cupomDescontoDigitado == null || cupomDescontoDigitado.trim().length == 0) {
            toastMensagemError("DIGITE O SEU CUPOM PARA INCLUIR!");
            return;
        }
        if (cupomDescontoDigitado == null || cupomDescontoDigitado.trim().length != 10) {
            toastMensagemError("CUPOM DIGITADO ESTÁ INVÁLIDO!");
            return;
        }

        if (usuarioLogado == "") {
            toastMensagemError("EFETUE SEU LOGIN PRIMEIRAMENTE!");
            return;
        }

        let __clienteID = usuarioLogado.split('_')[0];
        let __clienteIDLoja = usuarioLogado.split('_')[1];
        let creditoValido = api.get(`Pedidos/VerificarCredito/${__clienteID}/${__clienteIDLoja}/${cupomDescontoDigitado}`)
            .then((response) => {
                return response;
            })
            .then((data) => {
                if (data?.status == 200 && data?.data?.reasonPhrase != null) { // } && data?.reasonPhrase == null) {
                    // FALHA NO USO DO CRÉDITO
                    toastMensagemError(data?.data?.reasonPhrase);
                } else if (data?.status == 200 && data?.data?.reasonPhrase == null) {
                    // SUCESSO NO USO DO CRÉDITO
                    if (data != null) {
                        setMeusCreditosSelecionados(...meusCreditosSelecionados, [data?.data]);
                        toastConfirmadoPagamentoCartao("CUPOM INCLUÍDO COM SUCESSO!")
                    }
                }
                else {
                    toastMensagemError(data?.data?.error);
                }
            })
            .catch((error) => {
                toastMensagemError(error.message);
                return;
            });


        // let salvando = await api.post('Pedidos/VerificarCredito/', pedidosWebClass).then(res => {
        //     if (res.status == 200 && res?.data != null && res?.data?.message == null) {
        //         // SUCESSO NO PAGAMENTO                
        //         if (meuFormaPagamentoTipo == 1) {
        //             toastConfirmadoPagamentoCartao("PIX Criado com Sucesso");
        //         }
        //         if (meuFormaPagamentoTipo == 3) {
        //             setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
        //             toastConfirmadoPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
        //         }
        //         setRetornoApi(res.data);
        //         handleOpenModal();
        //     }   // if (res.status == 200 && res?.data != null && res?.data?.message == null){          
        //     if (res.status == 200 && res?.data != null && res?.data?.message != null && res?.data?.message.length > 0) {
        //         // FALHA NO PAGAMENTO DEVIDO A AUTORIZAÇÃO NEGADA PELA API DA REDE                
        //         setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
        //         toastFalhaPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
        //     }
        //     return res.data;
        // }).catch(err => {
        //     setFalhouPagamentos(err.response.data.returnCode + " - " + err.response.data.returnMessage);
        //     toastFalhaPagamentoCartao(err.response.data.returnCode + " - " + err.response.data.returnMessage);
        //     return false;
        // });
    }

    const ShowModalMeusCupons = (event) => {
        setShowModalMeusCreditos(true);
    }

    function MostrarOpcoesFretes() {
        if (pagamentoNumeroMaximoParcelas != null && Object.keys(pagamentoNumeroMaximoParcelas).length === 0) {
            setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
        }

        var elem = document.getElementById('cepFrete');
        var ultimoCEPDigitado = window.getCookie('nafil_ultimo_cep');

        if (fretes.length == 0 && cepDigitado.replace('-', '').length == 8) {

            if (typeof elem !== 'undefined' && ultimoCEPDigitado !== null && fretes != null && fretes.length === 0 || typeof elem !== 'undefined' && ultimoCEPDigitado !== null && cepDigitado != ultimoCEPDigitado) {
                let _voltouPesquisaFretes = PesquisarCEP(cepDigitado, null);
                // 02/09/2023 setAtualizarPagina(true);
            }
        }

        if (typeof elem !== 'undefined' && elem !== null && ultimoCEPDigitado !== null && ultimoCEPDigitado.length > 0 && document.getElementById("cepFrete").value == ultimoCEPDigitado) {
            document.getElementById("cepFrete").value = ultimoCEPDigitado;
        }

        return (
            <FormControl>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue=""
                    name="frete-selecionado"
                    sx={{ width: '500px' }}
                    style={{ display: 'flex' }}
                    value={(tipoFrete == -1 ? null : tipoFrete)}
                    //checked={(value, selectedValue) => selectedValue === value}
                    onChange={(e, value) => {
                        const optionFrete = fretes?.find(f => f.id == Number(value));
                        if (optionFrete) {
                            setTipoFrete(Number(value));
                            setCepEntregaSelecionado(optionFrete);
                        }
                    }
                    }
                >
                    {
                        fretes?.map((frete) => {
                            // CEP Localizado
                            return (
                                <div>
                                    <Grid container spacing={0.2} sx={{ alignItems: "center" }}>
                                        <Grid item xs={2} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '14px', fontWeight: 'bold', marginBottom: '10px' }}> {(frete.price * 1.312).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} </Grid>
                                        <Grid item xs={2.5}><FormControlLabel value={frete.id} control={<Radio {...props} size="small" color="success" id={frete.id} sx={{ marginBottom: '10px' }} />} label={frete.name} sx={{ '& .MuiFormControlLabel-label': { fontSize: '15px', marginBottom: '10px', marginLeft: '-7px' } }} /></Grid>
                                        <Grid item xs={2.5}><img src={frete?.company?.picture} alt={frete?.company?.picture} style={{ width: 'auto', height: '17px', marginBottom: '10px', marginLeft: '-4px' }} /> </Grid>
                                        <Grid item xs={2} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '14px', marginBottom: '10px', marginLeft: '5px' }}> {(frete?.delivery_time != null && frete?.delivery_time > 1 ? frete?.delivery_time + " Dias" : frete?.delivery_time + " Dia")}</Grid>
                                    </Grid>
                                </div>
                            );
                            // }
                            // else {
                            //     return(
                            //     <div>
                            //         <Grid container spacing={0.2} sx={{ alignItems: "center" }}>
                            //             <Grid item xs={12} sx={{ fontFamily: `"Roboto", "Helvetica", "Arial", "sans-serif"`, fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}> { frete.error }</Grid>
                            //         </Grid>
                            //     </div>);
                            // }
                        })
                    }
                </RadioGroup>
            </FormControl>);
    }

    const salvarDadosPedido = async (e) => {
        var __clienteID = 0;
        var __clienteIDLoja = 0;
        var __nomeUsuario = "";
        if (usuarioLogado == null || usuarioLogado.indexOf("_") == -1 || usuarioLogado == "") {
            toastMensagemError("Será Necessário Efetuar Login!");
            return;
        }
        else {
            __clienteID = usuarioLogado.split('_')[0];
            __clienteIDLoja = usuarioLogado.split('_')[1];
        }

        // Verifica Se o Meio de Transporte Foi Selecionado
        if (tipoFrete == -1) {
            toastFaltouSelecionarModoDeFrete("Selecione o Tipo de Frete Desejado");
            return;
        }
        setFechandoPedido(true);
        Recalculos();

        // Verifica Meio de Pagamento e Analisa se Está Todos Dados Preenchidos
        var listaItens = [];
        var listaEspecie = [];
        var listaPreVendasItensComMarcaClass = [];
        let _preVendasItem = preVendasItem;
        let _especie = especieItem;

        // tipo_integracao tabela 'especie'
        // 1 - POS
        // 2 - TEF
        // 3 - ON-LINE

        ////// 1 - PIX
        if (meuFormaPagamentoTipo == 1) {
            _especie.especie_id = 0;
            _especie.especie_loja = 998;  // 999
            _especie.venda_id = 0;
            _especie.venda_loja = 998; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = 'PIX';
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '';
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = '';
            _especie.nband = 17;  // 17 - 'PIX PAGAMENTO INSTANTÂNEO' tabela 'tipos_pagamentos'
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;
            listaEspecie.push(_especie);
        }
        else if (meuFormaPagamentoTipo == 2) { // BOLETOS BANCÁRIOS

            console.log("BOLETOS AAAA");

            _especie.especie_id = 0;
            _especie.especie_loja = 998; // 999
            _especie.venda_id = 0;
            _especie.venda_loja = 998; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = 'BOLETO BANCÁRIO';
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = pagamentoNumeroParcelas ?? 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '';
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = '';
            _especie.nband = 15;  // BOLETO BANCÁRIO
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;
            // _especie.pixTxid
            listaEspecie.push(_especie);
        }
        else if (meuFormaPagamentoTipo == 3) { // CARTÕES DE DÉBITO OU CRÉDITO
            if (VerificarDigitacaoCartoes() == false) {
                return;
            }
            _especie.especie_id = 0;
            _especie.especie_loja = 998; // 999
            _especie.venda_id = 0;
            _especie.venda_loja = 998; // 999
            _especie.data = '1997-01-01T00:00:00';
            _especie.tipo = ((3 + cartaoTipoCartao) == 4 ? 'CARTÃO DE DÉBITO' : 'CARTÃO DE CRÉDITO');
            _especie.valor = totalGeral ?? 0.00;
            _especie.vezes = pagamentoNumeroParcelas ?? 1;
            _especie.usuario = 0;
            _especie.caixa = 0;
            _especie.retorno = '';
            _especie.codctf = '';
            _especie.respdll = '';
            _especie.operadora_cnpj = '01425787000104'; // REDE CARD CNPJ OPERADORA
            _especie.cartao = '';
            _especie.bandeira = '';
            _especie.codautor = '';
            _especie.retautor = '';
            _especie.nsu = '';
            _especie.nsuautor = '';
            _especie.aprovacao = '';
            _especie.van = '';
            _especie.operadora = '';
            _especie.autorizadora = '';
            _especie.transacao = '1997-01-01T00:00:00';
            _especie.modo = '';
            _especie.resposta = '';
            _especie.nband = (3 + cartaoTipoCartao);  // 3 ou 4  - cartaoTipoCartao Seleciona Crédito 3 ou Débito 4
            _especie.disk = 1;
            _especie.finalizado = 0;
            _especie.tipo_integracao = 2;
            _especie.presencial = 0;
            _especie.ordem = 1;
            _especie.processo_id = 0;
            _especie.processo_id_loja = 0;

            // _especie.pixTxid
            listaEspecie.push(_especie);
        };

        let _modeloFreteTransportadora = await VerificarModeloFreteSelecionado(tipoFrete);

        let PreVendas = {
            ids_prevendas: 0,
            ids_prevendas_loja: 998, // 999
            filial: 998,  // 999 
            tipo: (meuFormaPagamentoTipo <= 2 ? 1 : 2),
            vendedor: 0,
            data: "1997-01-01T00:00:00",
            agendada: "1997-01-01T00:00:00",
            micro: "SITE",
            conferido_user: null, // 0
            conferido_data: null, // "0001-01-01T00:00:00",
            automatico: 0,
            total_produtos: totalProdutos,
            total_descontos: totalDescontos,
            total_frete: totalFrete,
            total_geral: totalGeral,
            caixa: 0,
            disk: 1,
            cliente_id: __clienteID,
            cliente_loja: __clienteIDLoja,
            cliente_cpf_cnpj: "",
            cliente_ie_rg: "",
            cliente_razao_social: "",
            cliente_fantasia: "",
            cliente_contato: "",
            cliente_telefone: "",
            endereco: meuEnderecoEntrega?.enderecos?.rua,
            numero: meuEnderecoEntrega?.enderecos?.numero,
            complemento: meuEnderecoEntrega?.enderecos?.complemento,
            referencia: meuEnderecoEntrega?.enderecos?.referencia,
            bairro: meuEnderecoEntrega?.enderecos?.bairro,
            id_uf: meuEnderecoEntrega?.enderecos?.iduf,
            id_cidade: meuEnderecoEntrega?.enderecos?.idcidade,
            id_pais: meuEnderecoEntrega?.enderecos?.bacen,
            ext_uf: meuEnderecoEntrega?.enderecos?.ext_uf,
            ext_cidade: meuEnderecoEntrega?.enderecos?.ext_cidade,
            cep: meuEnderecoEntrega?.enderecos?.cep,
            observacoes: "",
            situacao: 1,
            cancelada_user: null,
            cancelada_data: null,
            grupo: null,
            embalagem: null,
            lacre: 0,
            motoboy: 0,
            finalizado: 0,
            transporte_id: 0,
            transporte_loja: 0,
            transporte_rastreamento: "",
            faturado: 0, // ARRUMAR
            forma_pagamento: 0, // ARRUMAR
            operador: 0,
            cliente_filial: 0, // ARRUMAR
            f6: 0,
            transporte_modelo: "",
            transporte_data_saida: null,
            cliente_email: null,
            peso: 0.00,
            prazo_frete: 0,
            boleto_expira: null,
            web_app: 1,
            total_creditos: 0
        };

        let _PreVendasItensComMarcaClass = {
            PreVendasItens: preVendasItem,
        };

        console.log("TRECO -> ", _PreVendasItensComMarcaClass);

        meuCarrinho.forEach(function (meuCarrinho) {
            console.log("IN -> ", meuCarrinho);
            listaPreVendasItensComMarcaClass.push()
        });

        console.log("OUT -> ", listaPreVendasItensComMarcaClass);


        const dados = pedidosWebClass;
        PreVendas.prazo_frete = Number(fretes.filter((f) => f.id == tipoFrete)[0]?.delivery_time);
        dados.preVendas = PreVendas;
        dados.preVendasItens = meuCarrinho;

        console.log("BOLETOS BABY ", meuCarrinho);
        console.log("BOLETOS BBBB ", listaEspecie);

        dados.especie = listaEspecie;

        if (Object.keys(meuCreditoDetalhes).length === 0) {
            dados.creditos = null;

        } else {
            dados.creditos = meuCreditoDetalhes;
        }

        dados.idModeloTransporte = tipoFrete;  // ESCOLHE O MODELO DO FRETE DESEJADO
        dados.usuarioLogado = nomeFullRazaoSocialLogado.split(' ').slice(0, 2).join(' ').substring(0, 30).trim();
        dados.nomeUsuarioLogado = nomeUsuarioLogado;
        dados.preVendas.total_creditos = totalCreditos;
        dados.preVendas.total_descontos = totalDescontos;
        dados.preVendas.total_frete = totalFrete;
        dados.preVendas.total_produtos = totalProdutos;
        dados.preVendas.total_geral = totalGeral;


        // CARTAO DE CRÉDITO / DÉBITO
        if (meuFormaPagamentoTipo == 3) {
            dados.cartaoNumero = "MTz547kaAyyRP9xooknjJIbsewYSchF" + Buffer.from(cartaoDigitadoNumero).toString('base64');
            dados.cartaoValidade = "EvTIWqQ57d698BcmnIO65743aXkJ8511Dai" + Buffer.from(cartaoDigitadoValidade).toString('base64');
            dados.cartaoCVV = "GhiOoB1657pR8dSiexW25711Tr16unMS" + Buffer.from(cartaoDigitadoCVV).toString('base64');
            dados.cartaoNome = "cHJ32pdmF0ZSBzdGF0aWAMgcXmVhZG9ubSQHkgSHR0cESAXNsaWVudCBfQ2xpZ324W50ID0gbmV3I25OpEh0dHBDbGllSKlBvbnQoKTs" + Buffer.from(cartaoDigitadoNome.toUpperCase()).toString('base64');
        }
        setPedidosWebClass(dados);

        console.log('pedex ', dados);

        // const cookies = new Cookies();
        // const xsrfToken = cookies.get('XSRF-TOKEN');
        const xsrfToken = window.getCookie('XSRF-TOKEN');

        // console.log("XSRF-TOKEN", xsrfToken);
        // let CarambaClass = { 
        //     IdsPrevendas : "2223"
        // }
        // setPreVendaState({});
        // _prevenda.IdsPrevendas = 998; 
        // setPreVendaState(_prevenda);        
        // console.log("listaItens", listaItens);       

        console.log("UUUUUUUUU ", pedidosWebClass);

        let salvando = await api.post('Pedidos/SalvarPedido', pedidosWebClass).then(res => {
            console.log("UUUUUUUUU 01:", res);
            if (res.status == 200 && res?.data != null && res?.data?.message == null) {
                // SUCESSO NO PAGAMENTO      
                console.log("UUUUUUUUU 02:", res);
                if (meuFormaPagamentoTipo == 1) {
                    toastConfirmadoPagamentoCartao("PIX Criado com Sucesso");
                }
                if (meuFormaPagamentoTipo == 3) {
                    console.log("UUUUUUUUU 03:", res);
                    setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                    toastConfirmadoPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                }
                console.log("UUUUUUUUU 04:", res);
                console.log("UUUUUUUUU 05:", res?.data);
                setRetornoApi(res.data);
                handleOpenModal();
            }   // if (res.status == 200 && res?.data != null && res?.data?.message == null){          
            if (res.status == 200 && res?.data != null && res?.data?.message != null && res?.data?.message.length > 0) {
                // FALHA NO PAGAMENTO DEVIDO A AUTORIZAÇÃO NEGADA PELA API DA REDE                
                setFalhouPagamentos(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
                toastFalhaPagamentoCartao(res.data.cartaoRetornoCodigo + " - " + res.data.cartaoRetornoMessage);
            }

            console.log("SSSSSSS", res.data);

            return res.data;
        }).catch(err => {

            console.log("TTTTTTT", err);

            setFalhouPagamentos(err.response.data.returnCode + " - " + err.response.data.returnMessage);
            toastFalhaPagamentoCartao(err.response.data.returnCode + " - " + err.response.data.returnMessage);
            return false;
        });
    }

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 48 * 4.5 + 8,
                width: 250,
            },
        },
    };

    const ValidarEmail = (email) => {
        if (email.length === 0 || !email.includes('@') || !email.includes('.')) {
            return false;
        }
        else {
            return true;
        }
    }
    const ValidarSenha = (senha) => {
        if (senha.length === 0 || senha.length < 6) {
            return false;
        }
        else {
            return true;
        }
    }

    const toastErroEmail = () => toast.error("Por Favor, Utilize um E-Mail Válido!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroSenha = () => toast.error("Por Favor, Digite a Sua Senha!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroNaoCadastro = () => toast.warning("O E-Mail ou Senha Digitado Não Pode Ser Localizado!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
        { position: toast.POSITION.TOP_CENTER, theme: "colored" });

    const toastLoginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastFalhaPagamentoCartao = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 5000 });

    const toastConfirmadoPagamentoCartao = (message) => toast.success(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastMensagemError = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

    const toastFaltouSelecionarModoDeFrete = (message) => toast.error(message,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 5000 });



    useEffect(() => {
        setUsuarioLogado(identificacaoUsuarioLogado());
        setNomeUsuarioLogado(identificacaoNomeUsuarioLogado());
        setNomeFullRazaoSocialLogado(identificacaoRazaoSocialUsuarioLogado());
        AtualizarContadorCarrinho();
        PegarEnderecoPadrao();
        PegarDescontoAVista();
        MostrarOpcoesFretes();
        Recalculos();
    }, [meuCarrinho, meuFormaPagamentoTipo, confirmouCancelamento, cepEntregaSelecionado, meusCreditosSelecionados, atualizarPagina]);

    // useEffect(() => {              
    //     AtualizarContadorCarrinho();
    //     PegarEnderecoPadrao();        
    //     PegarDescontoAVista();
    //     MostrarOpcoesFretes();        
    //     Recalculos();     
    //     console.log("SQL C");
    // }, [atualizarPagina]);    


    function PegarDescontoAVista() {
        api.get('Prazos/DescontoAVistaPrazoPagamento').then((response) => {
            setDescontoPagamentoAVista(response?.data);
            setAtualizarPagina(true);
        }).catch((e) => {
            if (e == "Error: Network Error") {
                toastErroApiNaoResponde();
                setFreteError("Ops, Nosso Servidor Não Respondeu...");
                return null;
            }
            setFreteError(e);
            setDescontoPagamentoAVista(0.00);
            setAtualizarPagina(true);
            return null;
        });
    }

    function PegarEnderecoPadrao() {
        var _usuarioLogado = sessionStorage.getItem("id_loja_usuario");

        console.log("PEPA: ", _usuarioLogado);

        if (_usuarioLogado == null || _usuarioLogado == "") {
            return null;
        }
        // if (window.getCookie("nafil_endereco_entrega") == null || window.getCookie("nafil_endereco_entrega").length === 0) {
        var userLogado = identificacaoUsuarioLogado(_usuarioLogado);

        // var destinoCerto = window.getCookie("nafil_endereco_entrega");
        // destinoCerto = null;
        console.log("PEPB: ", _usuarioLogado);
        console.log("PEPC: ", userLogado);
        console.log("PEPD: ", 'Fretes/MeusEnderecos/PegarEnderecoPadrao/' + userLogado.split('_')[0] + `/` + userLogado.split('_')[1]);

        // console.log("PEPX: ", destinoCerto);

        // if (destinoCerto === null || destinoCerto.length === 0) {
        api.get('Fretes/MeusEnderecos/PegarEnderecoPadrao/' + userLogado.split('_')[0] + `/` + userLogado.split('_')[1]).then((response) => {
            if (meuEnderecoEntrega != response?.data) {
                setMeuEnderecoEntrega(response?.data);
                window.setCookie('nafil_endereco_entrega', "UYTsa32" + Buffer.from(JSON.stringify(response?.data)).toString('base64'), 365);
                // 02/09/2023  setAtualizarPagina(true);  // 30/08/2023
            }
        }).catch((e) => {
            if (e == "Error: Network Error") {
                toastErroApiNaoResponde();
                setFreteError("Ops, Nosso Servidor Não Respondeu...");
                return null;
            }
            setFreteError(e);
            return null;
        });
        // }
        // }
        // else {
        //     if (meuEnderecoEntrega?.enderecos?.ids_enderecos != JSON.parse(identificaoEnderecoEntrega())?.enderecos?.ids_enderecos) {
        //         setMeuEnderecoEntrega(JSON.parse(identificaoEnderecoEntrega()));
        //         // 02/09/2023  setAtualizarPagina(true);  // 30/08/2023
        //     }
        // }
    }

    function Recalculos() {
        var ultimoCEPDigitado = window.getCookie('nafil_ultimo_cep');
        // if (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0)
        // {
        //     PegarDescontoAVista();            
        // }
        let __totalProdutos = 0.00;
        let __totalFrete = 0.00;
        let __totalDescontos = 0.00;
        let __totalCreditos = 0.00;

        if (meusCreditosSelecionados != null && meusCreditosSelecionados.length > 0) {
            __totalCreditos = meusCreditosSelecionados.reduce((totalCreditos, item) => {
                return totalCreditos + item.valor;
            }, 0);
            setTotalCreditos(__totalCreditos);
        }
        else {
            __totalCreditos = 0.00;
            setTotalCreditos(__totalCreditos);
        }

        if (cepEntregaSelecionado != null && Object.keys(cepEntregaSelecionado).length > 0 && tipoFrete != -1) {
            __totalFrete = (cepEntregaSelecionado.price * 1.312);
            setTotalFrete(__totalFrete);
        }
        else {
            __totalFrete = 0.00;
            setTotalFrete(__totalFrete);
        }

        if (ultimoCEPDigitado) {
            setCepDigitado(ultimoCEPDigitado);
            var antes = document.getElementById("cepFrete");
            if (antes) {
                if (antes?.value?.length == 0) {
                    antes.value = ultimoCEPDigitado;
                }
            }
        }

        __totalProdutos = meuCarrinho.reduce((totalProdutos, item) => {
            return totalProdutos + (item.quantidade * item.preco);
        }, 0);

        setTotalProdutos(__totalProdutos);

        if (meuFormaPagamentoTipo == -1) {
            if (meuFormaPagamentoTipo <= 1) {
                TipoPagamento(1);
            } else {
                TipoPagamento(meuFormaPagamentoTipo);
            }
        }

        let _percentualDescontoAVista = (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
        __totalDescontos = (meuFormaPagamentoTipo <= 2 && __totalProdutos > descontoPagamentoAVista?.minimo ? __totalProdutos - (__totalProdutos * _percentualDescontoAVista) : 0.00);

        console.log("DescxA ", meuFormaPagamentoTipo);
        console.log("DescxB ", descontoPagamentoAVista);
        console.log("DescxC ", descontoPagamentoAVista.juros);
        console.log("DescxD ", descontoPagamentoAVista?.minimo);
        console.log("DescxE ", __totalProdutos);
        console.log("DescxF ", _percentualDescontoAVista);


        setTotalDescontos(__totalDescontos);
        setTotalGeral(Number((__totalProdutos + __totalFrete - __totalDescontos - __totalCreditos).toFixed(2)));
        setPagamentoValorParcelas(DividirParcelamentosCartoes());

        var elem = document.getElementById('cepFrete');
        if (typeof elem !== 'undefined' && elem !== null) {
            if (cepDigitado != document.getElementById('cepFrete').value) {
                PesquisarCEP(cepDigitado, null);  // Efetua Cotação dos Fretes Pelo Melhor Envio
            }
        }
    }

    function DividirParcelamentosCartoes() {
        var _valorDasParcelas = [];
        var _valorTotal = (totalProdutos + totalFrete - totalDescontos - totalCreditos);
        for (let i = 1; i <= Number(pagamentoNumeroMaximoParcelas?.prestacao ?? 1); i++) {
            _valorDasParcelas.push(i + ' x ' + (_valorTotal / i).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' sem juros');
        }
        return (_valorDasParcelas);
    }

    function TipoPagamento(value) {
        if (value <= 2) {
            setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
            setCartaoTipoCartao(0);
            TelaTipoDeCartaoCreditoOuDebito(0);
        } else {
            api.get('Prazos/' + totalGeral).then((response) => {
                setPagamentoNumeroMaximoParcelas(response?.data);
                setCartaoTipoCartao(0);
                TelaTipoDeCartaoCreditoOuDebito(0);
            }).catch((e) => {
                console.log(e);
            })
        }
        if (meuFormaPagamentoTipo != value) {
            setMeuFormaPagamentoTipo(value); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
        }
    }

    function PesquisarCEP(value, event) {
        if (value == null || value == "") {
            document.getElementById("cepFrete").value = "";
            setCepDigitado("");
            setHasCep(false);
            window.setCookie('nafil_ultimo_cep', '', 365);
            return;
        }
        setHasCep(true);
        if (event != null && event.key == "Backspace") {
            if (value.replace("-", "").length == 6) {
                value = value.substr(0, 5);
                return;
            }
            return;
        }
        else {
            if (event != null && event.key != "Delete" && event.key != "Tab" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                return;
            }
        }
        if (value != null && value.indexOf('-') == -1 && value.replaceAll("-", "").length == 5) {
            var antes = document.getElementById("cepFrete");
            antes.value = value + "-";
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
        if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
            var antes = document.getElementById("cepFrete");
            antes.value = value.replace("-", "");
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
        if (value != null && value.replaceAll("-", "").length == 8) {
            let _cepSemMascara = value.replaceAll("-", "");
            let _cepComMascara = _cepSemMascara.substr(0, 5) + "-" + _cepSemMascara.substr(5, 3);
            // CEP 27281-510 = 9
            if (cepDigitado != _cepComMascara) {
                setCepDigitado(_cepComMascara);
                setFreteError("Aguarde...");
            }

            // Montar Caixas Para o Cálculo do Envio 
            let _caixaMontada = { cep: "", quantidadeCaixas: 1, listaItensNaCaixa: [] };

            var itensNaCaixa = [];
            meuCarrinho.map((e) => {
                let _itm = {
                    // cep: _cepSemMascara, 
                    codigo: e.codigo,
                    quantidade: e.quantidade,
                    preco: e.preco,
                    desconto: 0.00, // ARRUMAR
                    peso: e.peso,
                    largura: e.largura,
                    comprimento: e.comprimento,
                    altura: e.altura
                };

                itensNaCaixa.push(_itm);
            });
            _caixaMontada = { cep: _cepSemMascara, quantidadeCaixas: 1, listaItensNaCaixa: itensNaCaixa };

            api.post(`Fretes/CotacaoMelhorEnvio`, _caixaMontada).then((response) => {
                // Comtém"ERROR" na Resposta da API     
                if (response?.data?.retornoME == null) {
                    setFretes([]);
                    setFreteError(response?.data?.error.toString());
                    toastMensagemError(response?.data?.error.toString());
                    // toastMensagemError(JSON.parse(response?.data?.autorizacao)["error"] );
                    // setFreteError(JSON.parse(response?.data?.autorizacao)["error"].toString());
                }
                else {
                    setCepEntregaSelecionado({});
                    setTipoFrete(-1);
                    setFretes(response?.data?.retornoME);
                    setFreteError("");
                    window.setCookie('nafil_ultimo_cep', _cepComMascara, 365);
                }
            }).catch((e) => {
                if (e == "Error: Network Error") {
                    toastErroApiNaoResponde();
                    setFreteError("Ops, Nosso Servidor Não Respondeu...");
                    return null;
                }
                setFreteError("CEP Não Foi Localizado!");
            })
        }
        if (value != null && value.length != 9) {
            if (event != null) {
                setFretes([]);
                setFreteError("");
            }
        }
    }

    function TestarCVV(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setVencimentoError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoCVV");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 3) {
                    setVencimentoError("CVV - Código de Segurança Inválido");
                    return;
                }
                else {
                    setVencimentoError("");
                    setCartaoDigitadoCVV(digitados);
                }
            }
        }
    }

    function TestarNomeCartao(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setCartaoNomeError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                setCartaoNomeError("");
                return;
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNome");
            var digitados = objDigitados.value;
            if (digitados != null) {
                // Testar CVV
                if (objDigitados.value != null && objDigitados.value.length < 2) {
                    setCartaoNomeError("Nome do Portador Inválido");
                    return;
                }
                else {
                    setCartaoNomeError("");
                    setCartaoDigitadoNome(digitados);
                }
            }
        }
    }

    function TestarNumeroCartaoCredito(value, event) {
        if (event != null && event.key == "Backspace") {
            setCartaoNumeroError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").length != 4) {
                    setCartaoNumeroError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoNumero");
            var digitados = objDigitados.value.replaceAll(" ", "").replace(/[^0-9]/, '');
            if (digitados != null) { // && digitados.length > 4) {
                var _bloco01 = digitados.substr(0, 4);
                var _bloco02 = (digitados.length > 4 ? digitados.substr(4, 4) : "");
                var _bloco03 = (digitados.length > 8 ? digitados.substr(8, 4) : "");
                var _bloco04 = (digitados.length > 12 ? digitados.substr(12, 4) : "");;
                objDigitados.value = _bloco01 + (_bloco02 != "" ? " " + _bloco02 : "") + (_bloco03 != "" ? " " + _bloco03 : "") + (_bloco04 != "" ? " " + _bloco04 : "");
                setCartaoNumeroError("");
            }
            if (digitados != null && digitados.length >= 15) {
                setCartaoSelecionado(CartaoCreditoTipo(digitados));
                setCartaoDigitadoNumero(digitados);
            }
        }
    }

    function TestarValidadeCartaoCredito(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            setVencimentoError("");
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll("/", "").replaceAll("-", "").replaceAll(" ", "").length != 4) {
                    setVencimentoError("");
                    return;
                }
            }
        }
        if (value != null) {
            var objDigitados = document.getElementById("cartaoValidade");
            var digitados = objDigitados.value.replaceAll("/", "").replaceAll("-", "");
            if (digitados != null) {
                objDigitados.value = (digitados.length >= 2 ? digitados.substr(0, 2) + "/" : digitados) + (digitados.length > 2 ? digitados.substr(2, digitados.length - 2) : "");

                // Testar Mês
                if (objDigitados.value != null && objDigitados.value.length >= 2) {
                    if (objDigitados.value.substr(0, 2) <= '00' || objDigitados.value.substr(0, 2) >= '13') {
                        setVencimentoError("Mês de Vencimento Inválido");
                        return;
                    }
                    else {
                        setVencimentoError("");
                    }
                }

                // Testar Ano
                if (objDigitados.value != null && objDigitados.value.length == 5) {
                    var anoAtual = new Date().getFullYear().toString();
                    if (objDigitados.value.substr(3, 2) <= '00' || anoAtual != null && objDigitados.value.substr(3, 2) < anoAtual.substring(2, 4)) {
                        setVencimentoError("Ano de Vencimento Inválido");
                        return;
                    } else {
                        setVencimentoError("");
                    }
                }
                setCartaoDigitadoValidade(objDigitados.value);
            }
        }
    }


    const logar = async (event) => {
        event.preventDefault();
        const userMail = document.getElementById('meuEmail');
        const userPassword = document.getElementById('minhaSenha');
        const vEmail = ValidarEmail(userMail.value);
        if (!vEmail) {
            toastErroEmail();
            return false;
        }
        const vSenha = ValidarSenha(userPassword.value);
        if (!vSenha) {
            setTipoFrete(-1);
            toastErroSenha();
            return false;
        }
        // setUsuarioAssociadoMaisUmaConta

        var verificarUsuarioMaisContas = api.get(`Clientes/ClienteContasAssociadas/${userMail.value}`)
            .then(res => {
                if (res.contasAssociadas > 1) {
                    setUsuarioAssociadoMaisUmaConta(true);
                }
                else {
                    setUsuarioAssociadoMaisUmaConta(false);
                }
                return true;
            }).catch(err => {
                if (err == "Error: Network Error") {
                    toastErroApiNaoResponde();
                }
                else {
                    toastErroNaoCadastro();
                }
                return false;
            });
        //

        const formData = new FormData();
        formData.append('email', userMail.value);
        formData.append('password', userPassword.value);
        const cookies = new Cookies();
        const xsrfToken = cookies.get('XSRF-TOKEN');

        var saveIn = await api.post('Clientes/Login', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'X-XSRF-TOKEN': xsrfToken
            }
        }).then(res => {
            toastLoginSucesso(res?.data?.razao_social.split(' ').slice(0, 2).join(' '));
            let razaoSocialUsuarioLogado = res?.data?.razao_social.split(' ').slice(0, 2).join(' ');
            let usuarioLogado = sessionStorage.getItem("id_loja_usuario");
            if (usuarioLogado) {
                sessionStorage.removeItem("id_loja_usuario");
                sessionStorage.removeItem("hash_usuario");
                sessionStorage.removeItem("nome_usuario_logado");
                sessionStorage.removeItem("nome_razao_social_logado");
                sessionStorage.removeItem("usuario_compras_faturado");
                var saveQuemLogou = Buffer.from(res?.data?.ids_clientes + "_" + res?.data?.ids_loja).toString('base64');
            }
            else {
                sessionStorage.removeItem("id_loja_usuario");
                sessionStorage.removeItem("hash_usuario");
                var saveQuemLogou = Buffer.from(res?.data?.ids_clientes + "_" + res?.data?.ids_loja).toString('base64');
                var saveNomeUsuarioQueLogou = Buffer.from(razaoSocialUsuarioLogado).toString('base64');
                sessionStorage.setItem("nome_razao_social_logado", "MRnSt" + Buffer.from(res?.data?.razao_social).toString('base64').replaceAll("=", "!") + "POsr34qa2esTraAb==");
                sessionStorage.setItem("nome_usuario_logado", "WsopOTy" + Buffer.from(res?.data?.nome).toString('base64').replaceAll("=", "!") + "XwQq43s741wOpUUsVbqa==");
                sessionStorage.setItem("id_loja_usuario", "Pr" + saveQuemLogou + "YfhR7sFdS53a==");
                sessionStorage.setItem("hash_usuario", "tW" + saveNomeUsuarioQueLogou.replaceAll("=", "!") + "ReH5jQUX681z==");
                sessionStorage.setItem("usuario_compras_faturado", res?.data?.faturado);
                usuarioLogado = sessionStorage.getItem("id_loja_usuario");

                setUsuarioLogado(usuarioLogado);
                setNomeFullRazaoSocialLogado(res?.data?.razao_social);
                setUsuarioLogado(res?.data?.ids_clientes + "_" + res?.data?.ids_loja);
                setNomeUsuarioLogado(res?.data?.nome);
                setUsuarioComprasFaturadas(res?.data?.faturado);
                PegarEnderecoPadrao();
                MostrarOpcoesFretes();
            }
            return true;
        }).catch(err => {
            sessionStorage.removeItem("id_loja_usuario");
            sessionStorage.removeItem("hash_usuario");
            sessionStorage.removeItem("nome_usuario_logado");
            sessionStorage.removeItem("nome_razao_social_logado");
            sessionStorage.removeItem("usuario_compras_faturado");
            if (err == "Error: Network Error") {
                toastErroApiNaoResponde();
            }
            else {
                toastErroNaoCadastro();
            }
            return false;
        });

        if (saveIn) {
            // Aguarda o Toast Para Enviar Outra Página
            await new Promise(resolve => setTimeout(resolve, 2000));
            // navigate.push('/home');
            // ATIVAR BOTAO FINALIZAR PEDIDO
        }
    }

    const deslogar = async (event) => {
        sessionStorage.removeItem("nome_razao_social_logado");
        sessionStorage.removeItem("nome_usuario_logado");
        sessionStorage.removeItem("id_loja_usuario");
        sessionStorage.removeItem("hash_usuario");
        sessionStorage.removeItem("usuario_compras_faturado");
        setUsuarioLogado("");
        setNomeUsuarioLogado("");
        setTipoFrete(-1);
        PegarEnderecoPadrao();
        MostrarOpcoesFretes();
        api.post(`/Login/logout`, {}, { withCredentials: true })
            .then((response) => {
                // console.log("REsP ", response);
            })
            .catch((error) => {
                console.log("REsP Ruim ", error);
                if (error == "Error: Network Error") {
                    toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
                    return null;
                }
            });

        // 02/09/2023  setAtualizarPagina(true); 
    }

    function PesquisarCPF_CNPJ(value, event) {
        // Teclas Aceitas
        if (event != null && event.key == "Backspace") {
            if (value.length == 12) {
                value = value.substr(0, 11);
                return;
            }
            return;
        }
        else {
            if (event != null && (event.ctrlKey == true && (event.key != "v" || event.key != "V")) && event.key != "Delete" && event.key != "Tab" && event.key != "ArrowLeft" && event.key != "ArrowRight" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
                event.preventDefault();
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 11 || value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length != 14) {
                    return;
                }
            }
        }
        // CNPJ
        if (value != null && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length >= 14) {
            var objDigitados = document.getElementById("cartaoCPF");
            var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
            if (digitados != null) {
                objDigitados.value = digitados.substr(0, 2) + "." + digitados.substr(2, 3) + "." + digitados.substr(5, 3) + "/" + digitados.substr(8, 4) + "-" + digitados.substr(12, 2);
                setCpf_cnpjError("");
            }
        }
        // CPF
        else {
            if (value != null && value.indexOf('.') == -1 && value.replaceAll("-", "").length == 3 || value != null && value.replaceAll("-", "").length == 7) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + ".";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length == 11 && value.indexOf('-') == -1) {
                var antes = document.getElementById("cartaoCPF");
                antes.value = value + "-";
                setCpf_cnpjError("");
            }
            if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
                var antes = document.getElementById("cepFrete");
                antes.value = value.replace("-", "");
                setCpf_cnpjError("");
            }
            if (value != null && value.indexOf('.') == -1 && value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                var objDigitados = document.getElementById("cartaoCPF");
                var digitados = objDigitados.value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
                if (digitados != null) {
                    objDigitados.value = digitados.substr(0, 3) + "." + digitados.substr(3, 3) + "." + digitados.substr(6, 3) + "-" + digitados.substr(9, 2);
                    setCpf_cnpjError("");
                }
            }
        }
        // Finalizado Digitação Vou Ferificar os Valores Digitados
        if (value != null) {
            if (validaCpfCnpj(value) == false) {
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 11) {
                    setCpf_cnpjError("CPF Inválido");
                }
                if (value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "").length == 14) {
                    setCpf_cnpjError("CNPJ Inválido");
                }
            }
            else {
                setCpf_cnpjError("");
            }
        }
    }

    function DeletarItemCarrinho(event, produto) {
        setOpenDialogo(true);
    }

    const handleClickOpen = (produto) => {
        SetDialogoMensagem(produto.codigo + " - " + produto.descricao + "?");
        setDialogoProduto(produto);
        setOpenDialogo(true);
    };

    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    const handleCloseNao = () => {
        setDialogoProduto({});
        setDialogoRetornoSim(false);
        setOpenDialogo(false);
    };

    const handleCloseSim = () => {
        setDialogoRetornoSim(true);
        DeletarCarrinho(dialogoProduto);
        setOpenDialogo(false);
    };

    function AdicionarCarrinho(event, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade += 1
            if (jaExiste.quantidade > produto.quantidadedisponivel) {
                jaExiste.quantidade = produto.quantidadedisponivel
            }
            setMeuCarrinho(meuCarrinho.slice(jaExiste))
        } else {

            if (meuCarrinho.length === 0) {
                produto.quantidade = 1;
                setMeuCarrinho([produto]);
            }
            else {
                produto.quantidade = 1;
                setMeuCarrinho(meuCarrinho => [...meuCarrinho, produto]);
            }
        }

        window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
        AtualizarContadorCarrinho();
        Recalculos();
    }

    function RemoverCarrinho(event, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade -= 1;
            if (jaExiste.quantidade <= 0) {
                jaExiste.quantidade = 1;
                SetDialogoMensagem(produto.codigo + " - " + produto.descricao + "?");
                setDialogoProduto(produto);
                setOpenDialogo(true);
            }
            // DeletarItemCarrinho(event, produto);
            let _meuCarrinhoAntesSet = meuCarrinho.slice(jaExiste);
            if (_meuCarrinhoAntesSet != null) {
                setMeuCarrinho(_meuCarrinhoAntesSet);
                window.setCookie("nafil_carrinho", JSON.stringify(_meuCarrinhoAntesSet), 31);
            }
        }
        Recalculos();
        AtualizarContadorCarrinho();
    }

    function DeletarCarrinho(produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        var _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
        if (jaExiste) {
            // DeletarItemCarrinho(event, produto, open, setOpen);
            jaExiste.quantidade = 0;
            if (jaExiste.quantidade <= 0) {
                jaExiste.quantidade = 0;
            }
        }
        _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
        setMeuCarrinho(_meuCarrinhoAntesSet);
        window.setCookie("nafil_carrinho", JSON.stringify(_meuCarrinhoAntesSet), 31);
        AtualizarContadorCarrinho();
    }

    function handleChange(e, produto) {
        let jaExiste = meuCarrinho.find(function (jaExiste) {
            return jaExiste.codigo == produto.codigo
        })
        if (jaExiste) {
            jaExiste.quantidade = e.target.value;
            if (jaExiste.quantidade > produto.quantidadedisponivel) {
                jaExiste.quantidade = produto.quantidadedisponivel
            }
            setMeuCarrinho(meuCarrinho.slice(jaExiste))
        }
        window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
        AtualizarContadorCarrinho();
    }

    function handleCheckBoxConcordo(e) {
        setConfirmouCancelamento(e?.target?.checked);
        setConfirmouCancelamentoError("");
    }

    const handleChangeComboParcelamentos = (event) => {
        const {
            target: { value },
        } = event;
        let _numeroParcelasSelecionada = Number(event?.target?.value.substr(0, event?.target?.value.indexOf("x")) ?? '0');
        setPagamentoNumeroParcelas(_numeroParcelasSelecionada);
        setPagamentoOpcaoSelecionada(
            // On autofill we get a stringified value.
            //typeof value === 'string' ? value.split(',') : value,
            typeof value === 'string' ? value : value,
        );
        setPagamentoNumeroParcelasError("");
    };

    function AtualizarContadorCarrinho() {
        let _NumeroProdutosSelecionados = 0;
        meuCarrinho.map((prod) => {
            _NumeroProdutosSelecionados += Number(prod.quantidade);
        });
        setCarrinhoCounter(_NumeroProdutosSelecionados ?? 0);
    }


    async function VerificarModeloFreteSelecionado(_tipoFrete) {
        await api.get(`Fretes/ModeloTransporte/${_tipoFrete}`).then(res => {
            setTipoFreteDados(res.data);
            return (res.data);

        }).catch(err => {
            setFreteError(err);
            return false;
        });
    }

    function TelaTipoDeCartaoCreditoOuDebito(modeloCartao) {
        // 0 - Cartão de Crédito / 1 -Cartão de Débito
        // 0 - Cartão de Crédito
        if (modeloCartao == 0) {
            setCartaoSolicitarCPF_CNPJ(true);
            setCartaoTipoCartao(0);
            setPagamentoNumeroParcelas(0);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
        // 1 -Cartão de Débito
        else if (modeloCartao == 1) {
            setCartaoSolicitarCPF_CNPJ(false);
            setCartaoTipoCartao(1);
            setPagamentoNumeroParcelas(1);
            setPagamentoOpcaoSelecionada("");
            setPagamentoNumeroParcelasError("");
        }
    }

    if (carrinhoCounter > 0) {
        // Carrinho Cheio
        let produtoAtual = "";
        return (
            <div>
                <BrowserView>
                    <Grid
                        container
                        direction="row"
                        marginTop='12px'
                        marginLeft='12px'
                    >
                        <Grid item xs={7.2}>
                            <Grid container spacing={1}>
                                {
                                    meuCarrinho.map((prod) => (
                                        <Grid item style={{ display: 'flex', minHeight: '200px' }}>
                                            <Box>
                                                <Card sx={{ width: 800, maxWidth: 800 }}>
                                                    <Grid container>
                                                        <Grid item xs={3} spacing={3} style={{ display: 'flex', minHeight: '200px', minWidth: '210px' }}>
                                                            <CardMedia
                                                                component="img"
                                                                height="180"
                                                                image={"https://www.nafil.com.br/images/produtos/gr/" + prod.codigo.toString().substr(0, 1) + "/" + prod.codigo.toString() + ".jpg"}
                                                                alt={prod.descricao}
                                                                onClick={(e) => abrirPaginaModalDetalhes(prod)}
                                                                sx={{ height: 'auto', width: 'auto', margin: 'auto', maxHeight: '190px', maxWidth: '210px' }}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={8.5} style={{ display: 'flex', minHeight: '200px', minWidth: '400px' }}>
                                                            <CardContent>
                                                                <Typography onClick={(e) => abrirPaginaModalDetalhes(prod)} gutterBottom variant="h7" component="div" textAlign={"left"} minWidth={'380px'} style={{ cursor: 'pointer' }} >
                                                                    <b>{prod.descricao}</b>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Nº Fabricante: <span><b>{prod.n_original}</b></span>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Fabricante: <b>{prod.id_marcaNavigation.descricao}</b>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Código: <b>{prod.codigo}</b>
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" textAlign={"left"}>
                                                                    Embalagem: {prod.emb_venda} - {prod.embalagem_peca}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" textAlign={"left"}>
                                                                    Garantia: <b>{prod.garantia}</b>* (Ver Cerificado)
                                                                </Typography>

                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Preço Unitário: <b>{prod.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} x {prod.quantidade} = {(prod.quantidade * prod.preco).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b>
                                                                </Typography>
                                                            </CardContent>

                                                            <Box sx={{ display: "flex", flex: 1, marginTop: '90px', alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px', maxWidth: '122px' }}>
                                                                <IconButton name="Remover" onClick={event => RemoverCarrinho(event, prod)}>
                                                                    <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                                                                </IconButton>

                                                                <Box width={47}>
                                                                    <TextField
                                                                        hiddenLabel
                                                                        type="tel"
                                                                        name={prod.codigo} id={prod.codigo}
                                                                        value={prod.quantidade}
                                                                        //defaultValue="Small"
                                                                        fullWidth
                                                                        size="small"
                                                                        inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                                                        sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                                                        onChange={(event) => { handleChange(event, prod); }}
                                                                    />
                                                                </Box>
                                                                <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, prod)}>
                                                                    <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                                </IconButton>
                                                            </Box>

                                                            <IconButton name="Deletar" onClick={(event) => handleClickOpen(prod)} sx={{ height: '30px', width: '30px' }}>
                                                                <DeleteIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                            </IconButton>
                                                        </Grid>
                                                    </Grid>

                                                </Card>
                                            </Box>
                                        </Grid>
                                    ))
                                }

                                <Grid item sx={{ width: 810, maxWidth: 810, minHeight: '100px' }}>

                                    {/* CUPOM DE DESCONTO INÍCIO */}
                                    <Card sx={{ bgcolor: '#F5F5F5', minHeight: '100px' }}>
                                        <CardContent>

                                            <Stack spacing={1} direction="row">
                                                <CardMedia
                                                    component="img"
                                                    height="60"
                                                    image={CupomDescontoIcon}
                                                    alt={"CupomDesconto"}
                                                    sx={{ height: '60px', width: 'auto', maxHeight: '60px', marginLeft: '16px' }}
                                                />

                                                <Box display={'flex'} alignContent={'center'} justifyContent={'center'} alignItems={'center'}>
                                                    <TextField id="cupomDescontoText" label="Digite Seu Cupom" variant="outlined" size="small" />
                                                    <Button onClick={() => UtilizarCreditoDigitado()} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginLeft: '20px' }}>Utilizar</Button>
                                                    <Button onClick={() => ShowModalMeusCupons()} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginLeft: '40px' }}>Verificar Meus Cupons</Button>
                                                </Box>
                                            </Stack>

                                        </CardContent>
                                    </Card>
                                    {/* CUPOM DE DESCONTO FINAL */}
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={4.7} alignContent={'left'} textAlign={'left'}>

                            {/* LOGIN INÍCIO */}

                            {usuarioLogado == "" ?

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginBottom: '8px' }}>
                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={ChaveIcon}
                                                style={{ borderRadius: 0, height: '20px', width: 'auto' }}
                                            />
                                            <Stack direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    login:
                                                </Typography>
                                                <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                    Para Finalizar o Pedido Será Necessário Efetuar Login
                                                </Typography>
                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />
                                                <Stack direction="column" spacing={1} >
                                                    <TextField
                                                        fullWidth
                                                        id="meuEmail"
                                                        name="meuEmail"
                                                        label="Digite o Seu E-Mail"
                                                        type="text"
                                                        size="small"
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        id="minhaSenha"
                                                        name="minhaSenha"
                                                        label="Senha"
                                                        type="password"
                                                        size="small"
                                                    />

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        marginTop='12px'
                                                        marginLeft='12px'
                                                    >
                                                        

                                                        <Grid item xs={6}>

                                                            <Button
                                                                variant="contained"
                                                                onClick={(e) =>
                                                                    logar(e)
                                                                }
                                                                style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}
                                                            >
                                                                Efetuar Login
                                                            </Button>
                                                        </Grid>

                                                        <Grid item xs={6}>

                                                            <Button
                                                                variant="contained"
                                                                onClick={(e) => { navigate.push("/cadastro") }
                                                                }
                                                                style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}
                                                            >
                                                                Cadastre-se
                                                            </Button>

                                                        </Grid>
                                                    </Grid>

                                                    <a href="#" style={{ marginLeft: '87px', fontSize: '14px' }}>Esqueci Minha Senha</a>
                                                    

                                                </Stack>

                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                :

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginBottom: '8px' }}>
                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={usuarioLogo}
                                                style={{ borderRadius: 0, height: '32px', width: 'auto' }}
                                            />
                                            <Stack direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    {nomeFullRazaoSocialLogado.split(' ').slice(0, 2).join(' ')}
                                                </Typography>
                                                <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                    {nomeUsuarioLogado}
                                                </Typography>
                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                <Stack direction="row" spacing={2} >
                                                    <Button
                                                        variant="contained"
                                                        onClick={(e) =>
                                                            deslogar(e)
                                                        }
                                                        style={{ backgroundColor: '#357a38', maxWidth: '160px', maxHeight: '25px' }}
                                                    >
                                                        Efetuar Logoff
                                                    </Button>

                                                    {/* <a href="#" style={{ fontSize: '14px' }}>Esvaziar Meu Carrinho</a>             */}

                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            }

                            {/* LOGIN FINAL */}

                            {/* FRETE INICIO  */}

                            {usuarioLogado === null || usuarioLogado === "" || usuarioLogado.length === 0 ?

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px' }}>

                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={LocalizacaoIcon}
                                                style={{ height: '50px', width: 'auto' }}
                                            />
                                            <Stack spacing={2} direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    Informe o seu CEP:
                                                    <a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" style={{ fontSize: '14px', marginLeft: '20px' }}>Não Sei Meu CEP</a>
                                                </Typography>
                                                <Stack spacing={2} direction="row">
                                                    <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                        <TextField id="cepFrete" name="cepFrete"
                                                            onKeyUp={(event) => {
                                                                PesquisarCEP(event.target.value, event)
                                                            }}
                                                            InputLabelProps={{ shrink: hasCep }}
                                                            inputProps={{ maxLength: 9 }}
                                                            label="Digite Seu CEP" variant="outlined" size="small" />
                                                        {/* onChange={(event) => PesquisarCEP(event.target.value)}  */}
                                                    </Typography>
                                                    <Button variant="contained" onClick={(event) => PesquisarCEP(document.getElementById("cepFrete").value, null)} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginLeft: '40px', marginTop: '6px' }}>CALCULAR ENTREGA</Button>
                                                </Stack>

                                                <Stack direction="column">
                                                    <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                        {(fretes.length == 0 || fretes[0]?.rua == null ? "" : fretes[0]?.rua)}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                        {(fretes.length == 0 || fretes[0]?.cidade == null ? "" : fretes[0]?.cidade + "-" + fretes[0]?.uf)}
                                                    </Typography>
                                                    <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                    {(fretes != null && Object.keys(fretes).length > 0 ? MostrarOpcoesFretes() : <></>)}

                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                :

                                <Box>
                                    <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px' }}>

                                        <CardContent>
                                            <Stack spacing={2} direction="row">
                                                <Avatar
                                                    src={LocalizacaoIcon}
                                                    style={{ height: '50px', width: 'auto' }}
                                                />
                                                <Stack spacing={2} direction="column">
                                                    <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                        Selecione o Endereço de Entrega:
                                                    </Typography>
                                                    <Stack spacing={2} direction="row">

                                                        <Grid container spacing={1}>
                                                            <Grid item>
                                                                <Typography variant="h5" color="text.primary" textAlign={"left"} style={{ fontSize: '15px' }}>
                                                                    <b>{nomeFullRazaoSocialLogado}</b><br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.rua + ', ' + meuEnderecoEntrega?.enderecos?.numero)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.bairro)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecoCidade + ' -  ' + meuEnderecoEntrega?.enderecoUF)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5))}
                                                                    {window.setCookie('nafil_ultimo_cep', meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5), 365)}
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : (cepDigitado != meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5) ? setCepDigitado(meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5)) : <></>))}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />
                                                            </Grid>
                                                            <Grid item>

                                                                {(fretes != null && Object.keys(fretes).length > 0 ? MostrarOpcoesFretes() : <></>)}

                                                                <ModalEndereco props={usuarioLogado} />
                                                            </Grid>
                                                        </Grid>

                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Box>
                            }

                            {/* FRETE FINAL */}

                            {/* PAGAMENTO PEDIDO INÍCIO */}

                            <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginTop: '8px' }}>
                                <CardContent>
                                    <Stack spacing={2} direction="row">
                                        <Avatar
                                            src={PagamentoIcon}
                                            style={{ borderRadius: 0, height: '34px', width: 'auto' }}
                                        />
                                        <Stack direction="column">
                                            <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                Formas de Pagamentos:
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                Algumas Formas de Pagamentos Possuem Descontos
                                            </Typography>
                                            <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                            <Stack direction="row" maxHeight={65}>
                                                <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '50px', maxHeight: '50px', marginTop: '8px', cursor: 'pointer' }} />
                                                <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '50px', maxHeight: '50px', marginLeft: '25px', marginTop: '8px', cursor: 'pointer' }} />
                                                <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} style={{ height: '50px', maxHeight: '50px', marginTop: '8px', marginLeft: '25px', cursor: 'pointer' }} />
                                            </Stack>
                                            <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                {(pagamentoNumeroMaximoParcelas?.prestacao != null && pagamentoNumeroMaximoParcelas?.prestacao > 1 ? "Parcelar em Até " + pagamentoNumeroMaximoParcelas?.prestacao + " Vezes ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeral / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " )." : "À Vista em " + pagamentoNumeroMaximoParcelas?.prestacao + " Vez ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeral / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " ).")}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                            </Card>

                            {/* PAGAMENTO PEDIDO FINAL */}

                            {/* RESUMO PEDIDO INÍCIO */}

                            <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px', marginTop: '8px' }}>
                                <CardContent>
                                    <Stack spacing={2} direction="row">
                                        <Avatar
                                            src={BagIcon}
                                            style={{ borderRadius: 0, height: '50px', width: 'auto' }}
                                        />
                                        <Stack direction="column">
                                            <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                Resumo do Pedido:
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                {(meuCarrinho?.length > 1 ? meuCarrinho?.length + " Itens" : meuCarrinho?.length + " Item")} no Carrinho Contendo {(carrinhoCounter > 1 ? " " + carrinhoCounter + " Produtos" : " " + carrinhoCounter + " Produto")}
                                            </Typography>
                                            <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                            <Grid container spacing={1}>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                    Sub-Total R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalProdutos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                {totalDescontos > 0.00
                                                    ?
                                                    <>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                            Descontos R$
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                            {totalDescontos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                    </>
                                                    :
                                                    <></>
                                                }

                                                {totalCreditos > 0.00
                                                    ?
                                                    <>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                            Créditos R$
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                            {totalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                    </>
                                                    :
                                                    <></>
                                                }

                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                    Frete R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalFrete.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                    <Divider orientation="horizontal" flexItem sx={{ marginTop: '5px', marginBottom: '5px' }} />
                                                </Grid>

                                                {

                                                    meuFormaPagamentoTipo < 3 ? <></> : <>

                                                        <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'left', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                            <FormControl>
                                                                <FormLabel id="demo-row-radio-buttons-group-label">Tipo de Cartão</FormLabel>
                                                                <RadioGroup
                                                                    row
                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    name="row-radio-buttons-group"
                                                                >
                                                                    <FormControlLabel value="CCredito" checked={cartaoTipoCartao === 0} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(0)} control={<Radio />} label="Crédito" />
                                                                    <FormControlLabel value="CDebito" checked={cartaoTipoCartao === 1} disabled={true} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(1)} control={<Radio />} label="Débito" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>

                                                        {cartaoSolicitarCPF_CNPJ ?
                                                            <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                <TextField id="cartaoCPF" name="cartaoCPF"
                                                                    onKeyUp={(event) => {
                                                                        PesquisarCPF_CNPJ(event.target.value, event)
                                                                    }}
                                                                    inputProps={{ maxLength: 18 }}
                                                                    label="CPF/CNPJ do Portador" variant="outlined" size="small"
                                                                    defaultValue={""}
                                                                />
                                                            </Grid>
                                                            : <></>}

                                                        <Grid item xs={5} style={{ display: 'flex', alignContent: 'left' }}>
                                                            <Box display={'flex'} alignContent={'center'} height={'70px'} width={'auto'} >
                                                                <img src={(cartaoSelecionado == null || cartaoSelecionado == "" ? cartoes_CVV : (cartaoSelecionado == 'VISA' ? cartoes_VISA : (cartaoSelecionado == 'MASTERCARD' ? cartoes_MASTERCARD : (cartaoSelecionado == 'AMEX' ? cartoes_AMEX :
                                                                    (cartaoSelecionado == 'DINERS' ? cartoes_DINERS : (cartaoSelecionado == 'ELO' ? cartoes_ELO : (cartaoSelecionado == 'HIPERCARD' ? cartoes_HIPERCARD : (cartaoSelecionado == 'HIPER' ? cartoes_HIPER : (cartaoSelecionado == 'CABAL' ? cartoes_CABAL : cartoes_CVV)))))))))} alt={cartaoSelecionado} />
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cpf_cnpjError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoNumero" name="cartaoNumero" fullWidth defaultValue={""} onKeyUp={(event) => {
                                                                TestarNumeroCartaoCredito(event.target.value, event)
                                                            }} inputProps={{ maxLength: 19 }} label="Número do Cartão" variant="outlined" size="small" />
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cartaoNumeroError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoNome" name="cartaoNome" fullWidth inputProps={{ maxLength: 100 }} label="Nome Completo Como Está no Cartão" onKeyUp={(event) => {
                                                                TestarNomeCartao(event.target.value, event)
                                                            }} variant="outlined" size="small"
                                                                defaultValue={""}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cartaoNomeError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={5} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoValidade" name="cartaoValidade"
                                                                onKeyUp={(event) => {
                                                                    TestarValidadeCartaoCredito(event.target.value, event)
                                                                }} inputProps={{ maxLength: 5 }} label="Validade MM/AA" variant="outlined" size="small" sx={{ marginTop: "8px" }}
                                                                defaultValue={""}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoCVV" name="cartaoCVV" onKeyUp={(event) => {
                                                                TestarCVV(event.target.value, event)
                                                            }} inputProps={{ maxLength: 4 }} label="CVV Código de Segurança" variant="outlined" size="small" sx={{ marginTop: "8px", marginLeft: '10px' }} fullWidth
                                                                defaultValue={""}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {vencimentoError}
                                                            </Typography>
                                                        </Grid>

                                                        {cartaoSolicitarCPF_CNPJ ?
                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="opcao_parcelamentos-label">Parcelamentos</InputLabel>
                                                                    <Select
                                                                        labelId="opcao_parcelamentos-label"
                                                                        id="opcao_parcelamentos"
                                                                        // multiple                                                                                                                
                                                                        value={pagamentoOpcaoSelecionada}
                                                                        onChange={handleChangeComboParcelamentos}
                                                                        input={<OutlinedInput label="Opção de Parcelamento" />}
                                                                        //renderValue={(selected) => selected.join(', ')}
                                                                        renderValue={(selected) => selected}
                                                                        MenuProps={MenuProps}
                                                                    >
                                                                        {pagamentoValorParcelas.map((parcela) => (
                                                                            <MenuItem key={parcela} value={parcela}>
                                                                                <Checkbox />
                                                                                <ListItemText primary={parcela} />
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            : <></>}

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {pagamentoNumeroParcelasError}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                }

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex', alignContent: 'left', textAlign: 'left' }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox color="error" defaultValue={confirmouCancelamento} onChange={(e) => handleCheckBoxConcordo(e)} />}
                                                            label={<Typography color="error">Concordo Caso Falte Algum Item Cancelamento Parcial ou Total (Entraremos em Contato)
                                                            </Typography>}
                                                        />
                                                        <Typography align='left'>
                                                            <Link
                                                                component="button"
                                                                variant="body2"
                                                                onClick={() => { setOpenQuestion(true); }}><img src={Question} alt="Duvidas" style={{ width: '20px', height: 'auto' }} />
                                                            </Link>
                                                        </Typography>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                    <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                        {confirmouCancelamentoError}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                    {!fechandoPedido
                                                        ?
                                                        // <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px' }} onClick={(e) => salvarDadosPedido(e)}>Finalizar Pedido</Button>
                                                        <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px' }}>Em Poucos Dias...</Button>
                                                        :
                                                        <CircularProgress color="success">Aguarde...</CircularProgress>
                                                    }
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                    <Typography color="error">{falhouPagamentos}</Typography>
                                                </Grid>
                                            </Grid>

                                        </Stack>
                                    </Stack>
                                </CardContent>

                            </Card>

                            {/* RESUMO PEDIDO FINAL */}

                        </Grid>
                    </Grid>

                    {
                        openDialogo ?
                            <Dialogo
                                cabecalho="Deseja Excluir do Carrinho"
                                mensagem={dialogoMensagem}
                                open={openDialogo}
                                handleCloseNao={handleCloseNao.bind(this)}
                                handleCloseSim={handleCloseSim.bind(this)}
                            />
                            : <div></div>
                    }
                    <ToastContainer />
                    {
                        (showModalMeuPedido ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={showModalMeuPedido}
                                    onClose={handleCloseModal}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={showModalMeuPedido}>
                                        <Box sx={modalStyle}>
                                            <DetalhesMeuPedido props={retornoApi} />
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }

                    {
                        (showModalMeusCreditos ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={showModalMeusCreditos}
                                    onClose={handleCloseModalMeusCreditos}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={showModalMeusCreditos}>
                                        <Box sx={modalStyle}>
                                            <DetalhesMeusCupons props={retornoApi} />
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }

                    {
                        (openQuestion ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={openQuestion}
                                    onClose={handleCloseModalQuestion}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={openQuestion}>
                                        {/* <Box sx={modalStyle}>
                                            <Typography>AAAA BBBB CCCC</Typography>
                                        </Box> */}
                                        <Box sx={modalStyleQuestions}>
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Porque Aceitar Devolução Total ou Parcial?
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Nosso estoque disponível para vendas online é o mesmo da loja física que está efetuando vendas isso poderia ocasionar a falta de algum produto ainda não atualizado no site.
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Caso isso ocorra entraremos em contato para que você decida o que deseja fazer com o seu pedido.
                                            </Typography>
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }
                </BrowserView>



                <MobileView>
                    <Grid
                        container
                        direction="row"
                        marginTop='12px'
                        marginLeft='12px'
                    >
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                {
                                    meuCarrinho.map((prod) => (
                                        <Grid item style={{ display: 'flex', minHeight: '200px' }}>
                                            <Box>
                                                <Card sx={{ width: "100%", maxWidth: 800 }}>
                                                    <Grid container>
                                                        <Grid item xs={12} spacing={3} style={{ display: 'flex', minHeight: '200px', minWidth: '210px' }}>
                                                            <CardMedia
                                                                component="img"
                                                                height="180"
                                                                image={"https://www.nafil.com.br/images/produtos/gr/" + prod.codigo.toString().substr(0, 1) + "/" + prod.codigo.toString() + ".jpg"}
                                                                alt={prod.descricao}
                                                                onClick={(e) => abrirPaginaModalDetalhes(prod)}
                                                                sx={{ height: 'auto', width: 'auto', margin: 'auto', maxHeight: '190px', maxWidth: '210px' }}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} style={{ display: 'flex', minHeight: '150px', minWidth: '200px', maxWidth: '100%' }}>
                                                            <CardContent>
                                                                <Typography onClick={(e) => abrirPaginaModalDetalhes(prod)} gutterBottom variant="h7" component="div" textAlign={"left"} minWidth={'250px'} maxWidth={'100%'} style={{ cursor: 'pointer' }}>
                                                                    <b>{prod.descricao}</b>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Nº Fabricante: <span><b>{prod.n_original}</b></span>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Fabricante: <b>{prod.id_marcaNavigation.descricao}</b>
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Código: <b>{prod.codigo}</b>
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" textAlign={"left"}>
                                                                    Embalagem: {prod.emb_venda} - {prod.embalagem_peca}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" textAlign={"left"}>
                                                                    Garantia: <b>{prod.garantia}</b>* (Ver Cerificado)
                                                                </Typography>
                                                                <Typography variant="body1" color="text.secondary" textAlign={"left"}>
                                                                    Preço Unitário: <b>{prod.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} x {prod.quantidade} = {(prod.quantidade * prod.preco).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</b>
                                                                </Typography>
                                                            </CardContent>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', minHeight: '60px', minWidth: '400px' }}>
                                                            <Grid container spacing={0}>
                                                                <Grid item xs={3}>
                                                                    <IconButton name="Deletar" onClick={(event) => handleClickOpen(prod)} sx={{ height: '30px', width: '30px' }}>
                                                                        <DeleteIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                                    </IconButton>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                </Grid>
                                                                <Grid item xs={6}>
                                                                    <Box sx={{ display: "flex", flex: 1, alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px', maxWidth: '122px' }}>
                                                                        <IconButton name="Remover" onClick={event => RemoverCarrinho(event, prod)}>
                                                                            <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                                                                        </IconButton>
                                                                        <Box width={47}>
                                                                            <TextField
                                                                                hiddenLabel
                                                                                type="tel"
                                                                                name={prod.codigo} id={prod.codigo}
                                                                                value={prod.quantidade}
                                                                                //defaultValue="Small"
                                                                                fullWidth
                                                                                size="small"
                                                                                inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                                                                sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                                                                onChange={(event) => { handleChange(event, prod); }}
                                                                            />
                                                                        </Box>
                                                                        <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, prod)}>
                                                                            <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                                                        </IconButton>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    </Grid>

                                                </Card>
                                            </Box>
                                        </Grid>
                                    ))
                                }

                                <Grid item sx={{ width: 810, maxWidth: 810, minHeight: '100px' }}>

                                    {/* CUPOM DE DESCONTO INÍCIO */}
                                    <Card sx={{ bgcolor: '#F5F5F5', minHeight: '110px' }}>
                                        <CardContent>
                                            <Stack spacing={1} direction="row">
                                                <CardMedia
                                                    component="img"
                                                    height="60"
                                                    image={CupomDescontoIcon}
                                                    alt={"CupomDesconto"}
                                                    sx={{ height: '45px', width: 'auto', maxHeight: '45px' }}
                                                />
                                                <Box display={'flex'} alignContent={'center'} justifyContent={'center'} alignItems={'center'}>
                                                    <Grid container spacing={0}>
                                                        <Grid item xs={12}>
                                                            <TextField id="cupomDescontoText" label="Digite Seu Cupom" variant="outlined" size="small" />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Button onClick={() => UtilizarCreditoDigitado()} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '20px' }}>Utilizar</Button>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Button onClick={() => ShowModalMeusCupons()} variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '25px', marginTop: '20px' }}>Meus Cupons</Button>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                    {/* CUPOM DE DESCONTO FINAL */}
                                </Grid>
                            </Grid>

                        </Grid>

                        <Grid item xs={12} alignContent={'left'} textAlign={'left'}>

                            {/* LOGIN INÍCIO */}

                            {usuarioLogado == "" ?

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginBottom: '8px', marginTop: '10px' }}>
                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={ChaveIcon}
                                                style={{ borderRadius: 0, height: '20px', width: 'auto' }}
                                            />
                                            <Stack direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    login:
                                                </Typography>
                                                <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                    Para Finalizar o Pedido Será Necessário Efetuar Login
                                                </Typography>
                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />
                                                <Stack direction="column" spacing={1} >
                                                    <TextField
                                                        fullWidth
                                                        id="meuEmail"
                                                        name="meuEmail"
                                                        label="Digite o Seu E-Mail"
                                                        type="text"
                                                        size="small"
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        id="minhaSenha"
                                                        name="minhaSenha"
                                                        label="Senha"
                                                        type="password"
                                                        size="small"
                                                    />

                                                    <Grid
                                                        container
                                                        direction="row"
                                                        marginTop='12px'
                                                        marginLeft='12px'
                                                    >
                                                        <Grid item xs={6}>

                                                            <Button
                                                                variant="contained"
                                                                onClick={(e) =>
                                                                    logar(e)
                                                                }
                                                                style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}
                                                            >
                                                                Efetuar Login
                                                            </Button>
                                                        </Grid>

                                                        <Grid item xs={6}>

                                                            <Button
                                                                variant="contained"
                                                                onClick={(e) => { navigate.push("/cadastro") }
                                                                }
                                                                style={{ backgroundColor: '#357a38', maxWidth: '140px', maxHeight: '25px', marginTop: '10px', marginBottom: '10px' }}
                                                            >
                                                                Cadastre-se
                                                            </Button>

                                                        </Grid>
                                                    </Grid>

                                                    <a href="#" style={{ marginLeft: '87px', fontSize: '14px' }}>Esqueci Minha Senha</a>

                                                </Stack>

                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                :

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginBottom: '8px' }}>
                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={usuarioLogo}
                                                style={{ borderRadius: 0, height: '32px', width: 'auto' }}
                                            />
                                            <Stack direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    {nomeFullRazaoSocialLogado.split(' ').slice(0, 2).join(' ')}
                                                </Typography>
                                                <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                    {nomeUsuarioLogado}
                                                </Typography>
                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                <Stack direction="row" spacing={2} >
                                                    <Button
                                                        variant="contained"
                                                        onClick={(e) =>
                                                            deslogar(e)
                                                        }
                                                        style={{ backgroundColor: '#357a38', maxWidth: '160px', maxHeight: '25px' }}
                                                    >
                                                        Efetuar Logoff
                                                    </Button>

                                                    {/* <a href="#" style={{ fontSize: '14px' }}>Esvaziar Meu Carrinho</a>             */}

                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            }

                            {/* LOGIN FINAL */}

                            {/* FRETE INICIO  */}

                            {usuarioLogado === null || usuarioLogado === "" || usuarioLogado.length === 0 ?

                                <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px' }}>

                                    <CardContent>
                                        <Stack spacing={2} direction="row">
                                            <Avatar
                                                src={LocalizacaoIcon}
                                                style={{ height: '50px', width: 'auto' }}
                                            />
                                            <Stack spacing={2} direction="column">
                                                <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                    Informe o seu CEP:
                                                    <br /><a href="https://buscacepinter.correios.com.br/app/endereco/index.php" target="_blank" style={{ fontSize: '14px', marginLeft: '20px' }}>Não Sei Meu CEP</a>
                                                </Typography>
                                                <Stack spacing={2} direction="row">
                                                    <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                        <TextField id="cepFrete" name="cepFrete"
                                                            onKeyUp={(event) => {
                                                                PesquisarCEP(event.target.value, event)
                                                            }}
                                                            InputLabelProps={{ shrink: hasCep }}
                                                            inputProps={{ maxLength: 9 }}
                                                            label="Digite Seu CEP" variant="outlined" size="small" />
                                                        {/* onChange={(event) => PesquisarCEP(event.target.value)}  */}
                                                    </Typography>
                                                    <Button variant="contained" onClick={(event) => PesquisarCEP(document.getElementById("cepFrete").value, null)} style={{ backgroundColor: '#357a38', maxHeight: '25px', marginLeft: '10px', marginTop: '6px' }}>CALCULAR</Button>
                                                </Stack>

                                                <Stack direction="column">
                                                    <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                        {(fretes.length == 0 || fretes[0]?.rua == null ? "" : fretes[0]?.rua)}
                                                    </Typography>
                                                    <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                        {(fretes.length == 0 || fretes[0]?.cidade == null ? "" : fretes[0]?.cidade + "-" + fretes[0]?.uf)}
                                                    </Typography>
                                                    <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                                    {(fretes != null && Object.keys(fretes).length > 0 ? MostrarOpcoesFretes() : <></>)}

                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </CardContent>
                                </Card>

                                :

                                <Box>
                                    <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px' }}>

                                        <CardContent>
                                            <Stack spacing={2} direction="row">
                                                <Avatar
                                                    src={LocalizacaoIcon}
                                                    style={{ height: '50px', width: 'auto' }}
                                                />
                                                <Stack spacing={2} direction="column">
                                                    <Typography variant="h6" color="text.primary" textAlign={"left"}>
                                                        Selecione o Endereço de Entrega:
                                                    </Typography>
                                                    <Stack spacing={2} direction="row">

                                                        <Grid container spacing={1}>
                                                            <Grid item>
                                                                <Typography variant="h5" color="text.primary" textAlign={"left"} style={{ fontSize: '15px' }}>
                                                                    <b>{nomeFullRazaoSocialLogado}</b><br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.rua + ', ' + meuEnderecoEntrega?.enderecos?.numero)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.bairro)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecoCidade + ' -  ' + meuEnderecoEntrega?.enderecoUF)}<br />
                                                                    {(meuEnderecoEntrega === null || meuEnderecoEntrega === undefined ? "" : meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5))}
                                                                    {window.setCookie('nafil_ultimo_cep', meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5), 365)}
                                                                    {(meuEnderecoEntrega !== undefined && cepDigitado != meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5) ? setCepDigitado(meuEnderecoEntrega?.enderecos?.cep?.substr(0, 5) + '-' + meuEnderecoEntrega?.enderecos?.cep?.substr(5)) : <></>)}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item>
                                                                <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />
                                                            </Grid>
                                                            <Grid item>

                                                                {(fretes != null && Object.keys(fretes).length > 0 ? MostrarOpcoesFretes() : <></>)}

                                                                <ModalEndereco props={usuarioLogado} />
                                                            </Grid>
                                                        </Grid>

                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                </Box>
                            }

                            {/* FRETE FINAL */}

                            {/* PAGAMENTO PEDIDO INÍCIO */}

                            <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginTop: '8px' }}>
                                <CardContent>
                                    <Stack spacing={2} direction="row">
                                        <Avatar
                                            src={PagamentoIcon}
                                            style={{ borderRadius: 0, height: '34px', width: 'auto' }}
                                        />
                                        <Stack direction="column">
                                            <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                Formas de Pagamentos:
                                            </Typography>
                                            <Typography sx={{ fontSize: '12px' }} color="text.primary" textAlign={"left"}>
                                                Algumas Formas de Pagamentos Possuem Descontos
                                            </Typography>
                                            <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                            <Stack direction="row" maxHeight={65}>
                                                <img src={(meuFormaPagamentoTipo == 1 ? pixIcon : pixIconDisabled)} onClick={(e) => TipoPagamento(1)} style={{ height: '35px', maxHeight: '35px', marginTop: '8px', cursor: 'pointer' }} />
                                                <img src={(meuFormaPagamentoTipo == 2 ? boletoIcon : boletoIconDisabled)} onClick={(e) => TipoPagamento(2)} style={{ height: '35px', maxHeight: '35px', marginLeft: '30px', marginTop: '8px', cursor: 'pointer' }} />
                                                <img src={(meuFormaPagamentoTipo == 3 ? cartoes_selecaoIcon : cartoes_selecaoIconDisabled)} onClick={(e) => TipoPagamento(3)} style={{ cursor: 'pointer', marginLeft: '30px', height: '35px', maxHeight: '35px', marginTop: '8px' }} />
                                            </Stack>
                                            <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                {(pagamentoNumeroMaximoParcelas?.prestacao != null && pagamentoNumeroMaximoParcelas?.prestacao > 1 ? "Parcelar em Até " + pagamentoNumeroMaximoParcelas?.prestacao + " Vezes ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeral / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " )." : "À Vista em " + pagamentoNumeroMaximoParcelas?.prestacao + " Vez ( " + pagamentoNumeroMaximoParcelas?.prestacao + " x " + (totalGeral / pagamentoNumeroMaximoParcelas?.prestacao).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + " ).")}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </CardContent>
                            </Card>

                            {/* PAGAMENTO PEDIDO FINAL */}

                            {/* RESUMO PEDIDO INÍCIO */}

                            <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '120px', marginTop: '8px' }}>
                                <CardContent>
                                    <Stack spacing={2} direction="row">
                                        <Avatar
                                            src={BagIcon}
                                            style={{ borderRadius: 0, height: '50px', width: 'auto' }}
                                        />
                                        <Stack direction="column">
                                            <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                                Resumo do Pedido:
                                            </Typography>
                                            <Typography sx={{ fontSize: '15px' }} color="text.primary" textAlign={"left"}>
                                                {(meuCarrinho?.length > 1 ? meuCarrinho?.length + " Itens" : meuCarrinho?.length + " Item")} no Carrinho Contendo {(carrinhoCounter > 1 ? " " + carrinhoCounter + " Produtos" : " " + carrinhoCounter + " Produto")}
                                            </Typography>
                                            <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                            <Grid container spacing={1}>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                    Sub-Total R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalProdutos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                {totalDescontos > 0.00
                                                    ?
                                                    <>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                            Descontos R$
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                            {totalDescontos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                    </>
                                                    :
                                                    <></>
                                                }

                                                {totalCreditos > 0.00
                                                    ?
                                                    <>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                            Créditos R$
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right', color: '#ff0000' }}>
                                                            {totalCreditos.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                        </Grid>
                                                        <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>
                                                    </>
                                                    :
                                                    <></>
                                                }

                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px' }}>
                                                    Frete R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalFrete.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}></Grid>

                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold' }}>
                                                    Total R$
                                                </Grid>
                                                <Grid item xs={4} style={{ display: 'flex', fontSize: '18px', fontWeight: 'bold', justifyContent: 'right', textAlign: 'right' }}>
                                                    {totalGeral.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace("R$", "")}
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                    <Divider orientation="horizontal" flexItem sx={{ marginTop: '5px', marginBottom: '5px' }} />
                                                </Grid>

                                                {

                                                    meuFormaPagamentoTipo < 3 ? <></> : <>

                                                        <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'left', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                            <FormControl>
                                                                <FormLabel id="demo-row-radio-buttons-group-label">Tipo de Cartão</FormLabel>
                                                                <RadioGroup
                                                                    row
                                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                                    name="row-radio-buttons-group"
                                                                >
                                                                    <FormControlLabel value="CCredito" checked={cartaoTipoCartao === 0} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(0)} control={<Radio />} label="Crédito" />
                                                                    <FormControlLabel value="CDebito" checked={cartaoTipoCartao === 1} disabled={true} onChange={(e) => TelaTipoDeCartaoCreditoOuDebito(1)} control={<Radio />} label="Débito" />
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </Grid>

                                                        {cartaoSolicitarCPF_CNPJ ?
                                                            <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right', bgcolor: '#ccc', alignItems: 'flex-end' }}>
                                                                <TextField id="cartaoCPF" name="cartaoCPF"
                                                                    onKeyUp={(event) => {
                                                                        PesquisarCPF_CNPJ(event.target.value, event)
                                                                    }}
                                                                    inputProps={{ maxLength: 18 }}
                                                                    label="CPF/CNPJ do Portador" variant="outlined" size="small"
                                                                    defaultValue={""}
                                                                />
                                                            </Grid>
                                                            : <></>}

                                                        <Grid item xs={5} style={{ display: 'flex', alignContent: 'left' }}>
                                                            <Box display={'flex'} alignContent={'center'} height={'70px'} width={'auto'} >
                                                                <img src={(cartaoSelecionado == null || cartaoSelecionado == "" ? cartoes_CVV : (cartaoSelecionado == 'VISA' ? cartoes_VISA : (cartaoSelecionado == 'MASTERCARD' ? cartoes_MASTERCARD : (cartaoSelecionado == 'AMEX' ? cartoes_AMEX :
                                                                    (cartaoSelecionado == 'DINERS' ? cartoes_DINERS : (cartaoSelecionado == 'ELO' ? cartoes_ELO : (cartaoSelecionado == 'HIPERCARD' ? cartoes_HIPERCARD : (cartaoSelecionado == 'HIPER' ? cartoes_HIPER : (cartaoSelecionado == 'CABAL' ? cartoes_CABAL : cartoes_CVV)))))))))} alt={cartaoSelecionado} />
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cpf_cnpjError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoNumero" name="cartaoNumero" fullWidth defaultValue={""} onKeyUp={(event) => {
                                                                TestarNumeroCartaoCredito(event.target.value, event)
                                                            }} inputProps={{ maxLength: 19 }} label="Número do Cartão" variant="outlined" size="small" />
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cartaoNumeroError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoNome" name="cartaoNome" fullWidth inputProps={{ maxLength: 100 }} label="Nome Completo Como Está no Cartão" onKeyUp={(event) => {
                                                                TestarNomeCartao(event.target.value, event)
                                                            }} variant="outlined" size="small"
                                                                defaultValue={""}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {cartaoNomeError}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid item xs={5} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoValidade" name="cartaoValidade"
                                                                onKeyUp={(event) => {
                                                                    TestarValidadeCartaoCredito(event.target.value, event)
                                                                }} inputProps={{ maxLength: 5 }} label="Validade MM/AA" variant="outlined" size="small" sx={{ marginTop: "8px" }}
                                                                defaultValue={""}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={7} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <TextField id="cartaoCVV" name="cartaoCVV" onKeyUp={(event) => {
                                                                TestarCVV(event.target.value, event)
                                                            }} inputProps={{ maxLength: 4 }} label="CVV Código de Segurança" variant="outlined" size="small" sx={{ marginTop: "8px", marginLeft: '10px' }} fullWidth
                                                                defaultValue={""}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {vencimentoError}
                                                            </Typography>
                                                        </Grid>

                                                        {cartaoSolicitarCPF_CNPJ ?
                                                            <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel id="opcao_parcelamentos-label">Parcelamentos</InputLabel>
                                                                    <Select
                                                                        labelId="opcao_parcelamentos-label"
                                                                        id="opcao_parcelamentos"
                                                                        // multiple                                                                                                                
                                                                        value={pagamentoOpcaoSelecionada}
                                                                        onChange={handleChangeComboParcelamentos}
                                                                        input={<OutlinedInput label="Opção de Parcelamento" />}
                                                                        //renderValue={(selected) => selected.join(', ')}
                                                                        renderValue={(selected) => selected}
                                                                        MenuProps={MenuProps}
                                                                    >
                                                                        {pagamentoValorParcelas.map((parcela) => (
                                                                            <MenuItem key={parcela} value={parcela}>
                                                                                <Checkbox />
                                                                                <ListItemText primary={parcela} />
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Grid>
                                                            : <></>}

                                                        <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                            <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                                {pagamentoNumeroParcelasError}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                }

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex', alignContent: 'left', textAlign: 'left' }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox color="error" defaultValue={confirmouCancelamento} onChange={(e) => handleCheckBoxConcordo(e)} />}
                                                            label={<Typography color="error">Concordo Caso Falte Algum Item Cancelamento Parcial ou Total (Entraremos em Contato)
                                                            </Typography>}
                                                        />
                                                        <Typography align='left'>
                                                            <Link
                                                                component="button"
                                                                variant="body2"
                                                                onClick={() => { setOpenQuestion(true); }}><img src={Question} alt="Duvidas" style={{ width: '20px', height: 'auto' }} />
                                                            </Link>
                                                        </Typography>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', fontSize: '18px', textAlign: 'right' }}>
                                                    <Typography sx={{ fontSize: '15px', color: '#FF0000' }} textAlign={"left"}>
                                                        {confirmouCancelamentoError}
                                                    </Typography>
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                    {!fechandoPedido
                                                        ?
                                                        <Button variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px' }} onClick={(e) => salvarDadosPedido(e)}>Finalizar Pedido</Button>
                                                        :
                                                        <CircularProgress color="success">Aguarde...</CircularProgress>
                                                    }
                                                </Grid>

                                                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', textAlign: 'center' }}>
                                                    <Typography color="error">{falhouPagamentos}</Typography>
                                                </Grid>
                                            </Grid>

                                        </Stack>
                                    </Stack>
                                </CardContent>

                            </Card>

                            {/* RESUMO PEDIDO FINAL */}

                        </Grid>
                    </Grid>

                    {
                        openDialogo ?
                            <Dialogo
                                cabecalho="Deseja Excluir do Carrinho"
                                mensagem={dialogoMensagem}
                                open={openDialogo}
                                handleCloseNao={handleCloseNao.bind(this)}
                                handleCloseSim={handleCloseSim.bind(this)}
                            />
                            : <div></div>
                    }
                    <ToastContainer />
                    {
                        (open ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={open}
                                    onClose={handleCloseModal}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={open}>
                                        <Box sx={modalStyle}>
                                            <DetalhesMeuPedido props={retornoApi} />
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }

                    {
                        (showModalMeusCreditos ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={showModalMeusCreditos}
                                    onClose={handleCloseModalMeusCreditos}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={showModalMeusCreditos}>
                                        <Box sx={modalStyle}>
                                            <DetalhesMeusCupons props={retornoApi} />
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }

                    {
                        (openQuestion ?
                            <div>
                                <Modal
                                    aria-labelledby="transition-modal-title"
                                    aria-describedby="transition-modal-description"
                                    open={openQuestion}
                                    onClose={handleCloseModalQuestion}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >
                                    <Fade in={openQuestion}>
                                        {/* <Box sx={modalStyle}>
                                            <Typography>AAAA BBBB CCCC</Typography>
                                        </Box> */}
                                        <Box sx={modalStyleQuestions}>
                                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                                Porque Aceitar Devolução Total ou Parcial?
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Nosso estoque disponível para vendas online é o mesmo da loja física que está efetuando vendas isso poderia ocasionar a falta de algum produto ainda não atualizado no site.
                                            </Typography>
                                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                                Caso isso ocorra entraremos em contato para que você decida o que deseja fazer com o seu pedido.
                                            </Typography>
                                        </Box>
                                    </Fade>
                                </Modal>
                            </div>
                            :
                            <div></div>)
                    }
                </MobileView>

                {
                    (
                        codigoClicado == null
                            ?
                            <></>
                            :
                            <ModalDetalhes props={codigoClicado} />
                    )
                }


            </div >
        );
    }
    else {
        // Carrinho Vazio
        return (
            <div>
                <Grid
                    container
                    spacing={3}
                    direction="row"
                    justify="center"
                    alignItems="stretch"
                >
                    <Grid item xs={12} minHeight={'450px'} style={{ marginTop: '20px' }}>
                        {(showLoading ? <><ProgressBar /></> : <></>)}
                        <img src={Carrinho_Vazio_Imagem} alt="Carrinho Vazio" style={{ width: '200px', height: 'auto' }} />
                        <Typography variant="h6">Ainda Nenhum Item Foi Adicionado</Typography>
                        <Typography variant="h6">a Seu Carrinho!</Typography>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default Carrinho_Produtos;